/**
 * Copyright IBM Corp. 2019, 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import { _ as _objectWithoutProperties, I as Icon, a as _extends } from '../Icon-a8cbe70a.js';
import React from 'react';
import '@carbon/icon-helpers';
import 'prop-types';

var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _circle, _circle2, _circle3, _circle4, _circle5, _path88, _circle6, _circle7, _circle8, _circle9, _circle10, _path89, _circle11, _circle12, _circle13, _circle14, _circle15, _path90, _circle16, _circle17, _circle18, _circle19, _circle20, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _path134, _path135, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _path136, _path137, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _path138, _path139, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _path140, _path141, _circle50, _path142, _path143, _circle51, _path144, _path145, _circle52, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _circle53, _path189, _path190, _circle54, _path191, _path192, _circle55, _path193, _path194, _circle56, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _circle57, _path300, _circle58, _path301, _circle59, _path302, _circle60, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458;

var _excluded = ["children"],
    _excluded2 = ["children"],
    _excluded3 = ["children"],
    _excluded4 = ["children"],
    _excluded5 = ["children"],
    _excluded6 = ["children"],
    _excluded7 = ["children"],
    _excluded8 = ["children"],
    _excluded9 = ["children"],
    _excluded10 = ["children"],
    _excluded11 = ["children"],
    _excluded12 = ["children"],
    _excluded13 = ["children"],
    _excluded14 = ["children"],
    _excluded15 = ["children"],
    _excluded16 = ["children"],
    _excluded17 = ["children"],
    _excluded18 = ["children"],
    _excluded19 = ["children"],
    _excluded20 = ["children"],
    _excluded21 = ["children"],
    _excluded22 = ["children"],
    _excluded23 = ["children"],
    _excluded24 = ["children"],
    _excluded25 = ["children"],
    _excluded26 = ["children"],
    _excluded27 = ["children"],
    _excluded28 = ["children"],
    _excluded29 = ["children"],
    _excluded30 = ["children"],
    _excluded31 = ["children"],
    _excluded32 = ["children"],
    _excluded33 = ["children"],
    _excluded34 = ["children"],
    _excluded35 = ["children"],
    _excluded36 = ["children"],
    _excluded37 = ["children"],
    _excluded38 = ["children"],
    _excluded39 = ["children"],
    _excluded40 = ["children"],
    _excluded41 = ["children"],
    _excluded42 = ["children"],
    _excluded43 = ["children"],
    _excluded44 = ["children"],
    _excluded45 = ["children"],
    _excluded46 = ["children"],
    _excluded47 = ["children"],
    _excluded48 = ["children"],
    _excluded49 = ["children"],
    _excluded50 = ["children"],
    _excluded51 = ["children"],
    _excluded52 = ["children"],
    _excluded53 = ["children"],
    _excluded54 = ["children"],
    _excluded55 = ["children"],
    _excluded56 = ["children"],
    _excluded57 = ["children"],
    _excluded58 = ["children"],
    _excluded59 = ["children"],
    _excluded60 = ["children"],
    _excluded61 = ["children"],
    _excluded62 = ["children"],
    _excluded63 = ["children"],
    _excluded64 = ["children"],
    _excluded65 = ["children"],
    _excluded66 = ["children"],
    _excluded67 = ["children"],
    _excluded68 = ["children"],
    _excluded69 = ["children"],
    _excluded70 = ["children"],
    _excluded71 = ["children"],
    _excluded72 = ["children"],
    _excluded73 = ["children"],
    _excluded74 = ["children"],
    _excluded75 = ["children"],
    _excluded76 = ["children"],
    _excluded77 = ["children"],
    _excluded78 = ["children"],
    _excluded79 = ["children"],
    _excluded80 = ["children"],
    _excluded81 = ["children"],
    _excluded82 = ["children"],
    _excluded83 = ["children"],
    _excluded84 = ["children"],
    _excluded85 = ["children"],
    _excluded86 = ["children"],
    _excluded87 = ["children"],
    _excluded88 = ["children"],
    _excluded89 = ["children"],
    _excluded90 = ["children"],
    _excluded91 = ["children"],
    _excluded92 = ["children"],
    _excluded93 = ["children"],
    _excluded94 = ["children"],
    _excluded95 = ["children"],
    _excluded96 = ["children"],
    _excluded97 = ["children"],
    _excluded98 = ["children"],
    _excluded99 = ["children"],
    _excluded100 = ["children"],
    _excluded101 = ["children"],
    _excluded102 = ["children"],
    _excluded103 = ["children"],
    _excluded104 = ["children"],
    _excluded105 = ["children"],
    _excluded106 = ["children"],
    _excluded107 = ["children"],
    _excluded108 = ["children"],
    _excluded109 = ["children"],
    _excluded110 = ["children"],
    _excluded111 = ["children"],
    _excluded112 = ["children"],
    _excluded113 = ["children"],
    _excluded114 = ["children"],
    _excluded115 = ["children"],
    _excluded116 = ["children"],
    _excluded117 = ["children"],
    _excluded118 = ["children"],
    _excluded119 = ["children"],
    _excluded120 = ["children"],
    _excluded121 = ["children"],
    _excluded122 = ["children"],
    _excluded123 = ["children"],
    _excluded124 = ["children"],
    _excluded125 = ["children"],
    _excluded126 = ["children"],
    _excluded127 = ["children"],
    _excluded128 = ["children"],
    _excluded129 = ["children"],
    _excluded130 = ["children"],
    _excluded131 = ["children"],
    _excluded132 = ["children"],
    _excluded133 = ["children"],
    _excluded134 = ["children"],
    _excluded135 = ["children"],
    _excluded136 = ["children"],
    _excluded137 = ["children"],
    _excluded138 = ["children"],
    _excluded139 = ["children"],
    _excluded140 = ["children"],
    _excluded141 = ["children"],
    _excluded142 = ["children"],
    _excluded143 = ["children"],
    _excluded144 = ["children"],
    _excluded145 = ["children"],
    _excluded146 = ["children"],
    _excluded147 = ["children"],
    _excluded148 = ["children"],
    _excluded149 = ["children"],
    _excluded150 = ["children"],
    _excluded151 = ["children"],
    _excluded152 = ["children"],
    _excluded153 = ["children"],
    _excluded154 = ["children"],
    _excluded155 = ["children"],
    _excluded156 = ["children"],
    _excluded157 = ["children"],
    _excluded158 = ["children"],
    _excluded159 = ["children"],
    _excluded160 = ["children"],
    _excluded161 = ["children"],
    _excluded162 = ["children"],
    _excluded163 = ["children"],
    _excluded164 = ["children"],
    _excluded165 = ["children"],
    _excluded166 = ["children"],
    _excluded167 = ["children"],
    _excluded168 = ["children"],
    _excluded169 = ["children"],
    _excluded170 = ["children"],
    _excluded171 = ["children"],
    _excluded172 = ["children"],
    _excluded173 = ["children"],
    _excluded174 = ["children"],
    _excluded175 = ["children"],
    _excluded176 = ["children"],
    _excluded177 = ["children"],
    _excluded178 = ["children"],
    _excluded179 = ["children"],
    _excluded180 = ["children"],
    _excluded181 = ["children"],
    _excluded182 = ["children"],
    _excluded183 = ["children"],
    _excluded184 = ["children"],
    _excluded185 = ["children"],
    _excluded186 = ["children"],
    _excluded187 = ["children"],
    _excluded188 = ["children"],
    _excluded189 = ["children"],
    _excluded190 = ["children"],
    _excluded191 = ["children"],
    _excluded192 = ["children"],
    _excluded193 = ["children"],
    _excluded194 = ["children"],
    _excluded195 = ["children"],
    _excluded196 = ["children"],
    _excluded197 = ["children"],
    _excluded198 = ["children"],
    _excluded199 = ["children"],
    _excluded200 = ["children"],
    _excluded201 = ["children"],
    _excluded202 = ["children"],
    _excluded203 = ["children"],
    _excluded204 = ["children"],
    _excluded205 = ["children"],
    _excluded206 = ["children"],
    _excluded207 = ["children"],
    _excluded208 = ["children"],
    _excluded209 = ["children"],
    _excluded210 = ["children"],
    _excluded211 = ["children"],
    _excluded212 = ["children"],
    _excluded213 = ["children"],
    _excluded214 = ["children"],
    _excluded215 = ["children"],
    _excluded216 = ["children"],
    _excluded217 = ["children"],
    _excluded218 = ["children"],
    _excluded219 = ["children"],
    _excluded220 = ["children"],
    _excluded221 = ["children"],
    _excluded222 = ["children"],
    _excluded223 = ["children"],
    _excluded224 = ["children"],
    _excluded225 = ["children"],
    _excluded226 = ["children"],
    _excluded227 = ["children"],
    _excluded228 = ["children"],
    _excluded229 = ["children"],
    _excluded230 = ["children"],
    _excluded231 = ["children"],
    _excluded232 = ["children"],
    _excluded233 = ["children"],
    _excluded234 = ["children"],
    _excluded235 = ["children"],
    _excluded236 = ["children"],
    _excluded237 = ["children"],
    _excluded238 = ["children"],
    _excluded239 = ["children"],
    _excluded240 = ["children"],
    _excluded241 = ["children"],
    _excluded242 = ["children"],
    _excluded243 = ["children"],
    _excluded244 = ["children"],
    _excluded245 = ["children"],
    _excluded246 = ["children"],
    _excluded247 = ["children"],
    _excluded248 = ["children"],
    _excluded249 = ["children"],
    _excluded250 = ["children"];
var didWarnAboutDeprecation = {};
var Portfolio24 = /*#__PURE__*/React.forwardRef(function Portfolio24(_ref, ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28,10H22V6a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2v4H4a2,2,0,0,0-2,2V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10ZM12,6h8v4H12ZM4,26V12H28V26Z"
  })), children);
});
var Portfolio20 = /*#__PURE__*/React.forwardRef(function Portfolio20(_ref2, ref) {
  var children = _ref2.children,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28,10H22V6a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2v4H4a2,2,0,0,0-2,2V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10ZM12,6h8v4H12ZM4,26V12H28V26Z"
  })), children);
});
var Portfolio16 = /*#__PURE__*/React.forwardRef(function Portfolio16(_ref3, ref) {
  var children = _ref3.children,
      rest = _objectWithoutProperties(_ref3, _excluded3);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28,10H22V6a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2v4H4a2,2,0,0,0-2,2V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10ZM12,6h8v4H12ZM4,26V12H28V26Z"
  })), children);
});
var Power32 = /*#__PURE__*/React.forwardRef(function Power32(_ref4, ref) {
  var children = _ref4.children,
      rest = _objectWithoutProperties(_ref4, _excluded4);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,5.74l-1,1.73a11,11,0,1,1-11,0l-1-1.73a13,13,0,1,0,13,0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2H17V16H15z"
  })), children);
});
var Power24 = /*#__PURE__*/React.forwardRef(function Power24(_ref5, ref) {
  var children = _ref5.children,
      rest = _objectWithoutProperties(_ref5, _excluded5);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,5.74l-1,1.73a11,11,0,1,1-11,0l-1-1.73a13,13,0,1,0,13,0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2H17V16H15z"
  })), children);
});
var Power20 = /*#__PURE__*/React.forwardRef(function Power20(_ref6, ref) {
  var children = _ref6.children,
      rest = _objectWithoutProperties(_ref6, _excluded6);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,5.74l-1,1.73a11,11,0,1,1-11,0l-1-1.73a13,13,0,1,0,13,0Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2H17V16H15z"
  })), children);
});
var Power16 = /*#__PURE__*/React.forwardRef(function Power16(_ref7, ref) {
  var children = _ref7.children,
      rest = _objectWithoutProperties(_ref7, _excluded7);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2,2.9l-0.5,0.9c2.6,1.5,3.5,4.9,2,7.5s-4.9,3.5-7.5,2s-3.5-4.9-2-7.5c0.5-0.8,1.2-1.5,2-2L4.8,2.9\tc-3.1,1.8-4.2,5.8-2.4,8.9s5.8,4.2,8.9,2.4s4.2-5.8,2.4-8.9C13.1,4.3,12.2,3.4,11.2,2.9z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 1H8.5V8H7.5z"
  })), children);
});
var Ppt32 = /*#__PURE__*/React.forwardRef(function Ppt32(_ref8, ref) {
  var children = _ref8.children,
      rest = _objectWithoutProperties(_ref8, _excluded8);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22 11L25 11 25 23 27 23 27 11 30 11 30 9 22 9 22 11zM14 23H12V9h6a2.002 2.002 0 012 2v5a2.002 2.002 0 01-2 2H14zm0-7h4V10.9985H14zM4 23H2V9H8a2.002 2.002 0 012 2v5a2.002 2.002 0 01-2 2H4zm0-7H8V10.9985H4z"
  })), children);
});
var Ppt24 = /*#__PURE__*/React.forwardRef(function Ppt24(_ref9, ref) {
  var children = _ref9.children,
      rest = _objectWithoutProperties(_ref9, _excluded9);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22 11L25 11 25 23 27 23 27 11 30 11 30 9 22 9 22 11zM14 23H12V9h6a2.002 2.002 0 012 2v5a2.002 2.002 0 01-2 2H14zm0-7h4V10.9985H14zM4 23H2V9H8a2.002 2.002 0 012 2v5a2.002 2.002 0 01-2 2H4zm0-7H8V10.9985H4z"
  })), children);
});
var Ppt20 = /*#__PURE__*/React.forwardRef(function Ppt20(_ref10, ref) {
  var children = _ref10.children,
      rest = _objectWithoutProperties(_ref10, _excluded10);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22 11L25 11 25 23 27 23 27 11 30 11 30 9 22 9 22 11zM14 23H12V9h6a2.002 2.002 0 012 2v5a2.002 2.002 0 01-2 2H14zm0-7h4V10.9985H14zM4 23H2V9H8a2.002 2.002 0 012 2v5a2.002 2.002 0 01-2 2H4zm0-7H8V10.9985H4z"
  })), children);
});
var Ppt16 = /*#__PURE__*/React.forwardRef(function Ppt16(_ref11, ref) {
  var children = _ref11.children,
      rest = _objectWithoutProperties(_ref11, _excluded11);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M22 11L25 11 25 23 27 23 27 11 30 11 30 9 22 9 22 11zM14 23H12V9h6a2.002 2.002 0 012 2v5a2.002 2.002 0 01-2 2H14zm0-7h4V10.9985H14zM4 23H2V9H8a2.002 2.002 0 012 2v5a2.002 2.002 0 01-2 2H4zm0-7H8V10.9985H4z"
  })), children);
});
var PresentationFile32 = /*#__PURE__*/React.forwardRef(function PresentationFile32(_ref12, ref) {
  var children = _ref12.children,
      rest = _objectWithoutProperties(_ref12, _excluded12);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M15 10H17V18H15zM20 14H22V18H20zM10 12H12V18H10z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M25,4H17V2H15V4H7A2,2,0,0,0,5,6V20a2,2,0,0,0,2,2h8v6H11v2H21V28H17V22h8a2,2,0,0,0,2-2V6A2,2,0,0,0,25,4Zm0,16H7V6H25Z"
  })), children);
});
var PresentationFile24 = /*#__PURE__*/React.forwardRef(function PresentationFile24(_ref13, ref) {
  var children = _ref13.children,
      rest = _objectWithoutProperties(_ref13, _excluded13);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M15 10H17V18H15zM20 14H22V18H20zM10 12H12V18H10z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M25,4H17V2H15V4H7A2,2,0,0,0,5,6V20a2,2,0,0,0,2,2h8v6H11v2H21V28H17V22h8a2,2,0,0,0,2-2V6A2,2,0,0,0,25,4Zm0,16H7V6H25Z"
  })), children);
});
var PresentationFile20 = /*#__PURE__*/React.forwardRef(function PresentationFile20(_ref14, ref) {
  var children = _ref14.children,
      rest = _objectWithoutProperties(_ref14, _excluded14);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M15 10H17V18H15zM20 14H22V18H20zM10 12H12V18H10z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M25,4H17V2H15V4H7A2,2,0,0,0,5,6V20a2,2,0,0,0,2,2h8v6H11v2H21V28H17V22h8a2,2,0,0,0,2-2V6A2,2,0,0,0,25,4Zm0,16H7V6H25Z"
  })), children);
});
var PresentationFile16 = /*#__PURE__*/React.forwardRef(function PresentationFile16(_ref15, ref) {
  var children = _ref15.children,
      rest = _objectWithoutProperties(_ref15, _excluded15);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M15 10H17V18H15zM20 14H22V18H20zM10 12H12V18H10z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M25,4H17V2H15V4H7A2,2,0,0,0,5,6V20a2,2,0,0,0,2,2h8v6H11v2H21V28H17V22h8a2,2,0,0,0,2-2V6A2,2,0,0,0,25,4Zm0,16H7V6H25Z"
  })), children);
});
var Pressure32 = /*#__PURE__*/React.forwardRef(function Pressure32(_ref16, ref) {
  var children = _ref16.children,
      rest = _objectWithoutProperties(_ref16, _excluded16);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5053,16l8.1591-7.2529A1,1,0,0,0,25,7H22V2H20V9h2.37L16,14.6621,9.63,9H12V2H10V7H7a1,1,0,0,0-.6646,1.7471L14.4945,16,6.3353,23.2529A1,1,0,0,0,7,25h3v5h2V23H9.63L16,17.3379,22.37,23H20v7h2V25h3a1,1,0,0,0,.6645-1.7471Z"
  })), children);
});
var Pressure24 = /*#__PURE__*/React.forwardRef(function Pressure24(_ref17, ref) {
  var children = _ref17.children,
      rest = _objectWithoutProperties(_ref17, _excluded17);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5053,16l8.1591-7.2529A1,1,0,0,0,25,7H22V2H20V9h2.37L16,14.6621,9.63,9H12V2H10V7H7a1,1,0,0,0-.6646,1.7471L14.4945,16,6.3353,23.2529A1,1,0,0,0,7,25h3v5h2V23H9.63L16,17.3379,22.37,23H20v7h2V25h3a1,1,0,0,0,.6645-1.7471Z"
  })), children);
});
var Pressure20 = /*#__PURE__*/React.forwardRef(function Pressure20(_ref18, ref) {
  var children = _ref18.children,
      rest = _objectWithoutProperties(_ref18, _excluded18);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5053,16l8.1591-7.2529A1,1,0,0,0,25,7H22V2H20V9h2.37L16,14.6621,9.63,9H12V2H10V7H7a1,1,0,0,0-.6646,1.7471L14.4945,16,6.3353,23.2529A1,1,0,0,0,7,25h3v5h2V23H9.63L16,17.3379,22.37,23H20v7h2V25h3a1,1,0,0,0,.6645-1.7471Z"
  })), children);
});
var Pressure16 = /*#__PURE__*/React.forwardRef(function Pressure16(_ref19, ref) {
  var children = _ref19.children,
      rest = _objectWithoutProperties(_ref19, _excluded19);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5053,16l8.1591-7.2529A1,1,0,0,0,25,7H22V2H20V9h2.37L16,14.6621,9.63,9H12V2H10V7H7a1,1,0,0,0-.6646,1.7471L14.4945,16,6.3353,23.2529A1,1,0,0,0,7,25h3v5h2V23H9.63L16,17.3379,22.37,23H20v7h2V25h3a1,1,0,0,0,.6645-1.7471Z"
  })), children);
});
var PressureFilled32 = /*#__PURE__*/React.forwardRef(function PressureFilled32(_ref20, ref) {
  var children = _ref20.children,
      rest = _objectWithoutProperties(_ref20, _excluded20);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M22 30H10V25H6l10-9 10 9H22zM16 16L6 7h4V2H22V7h4z"
  })), children);
});
var PressureFilled24 = /*#__PURE__*/React.forwardRef(function PressureFilled24(_ref21, ref) {
  var children = _ref21.children,
      rest = _objectWithoutProperties(_ref21, _excluded21);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M22 30H10V25H6l10-9 10 9H22zM16 16L6 7h4V2H22V7h4z"
  })), children);
});
var PressureFilled20 = /*#__PURE__*/React.forwardRef(function PressureFilled20(_ref22, ref) {
  var children = _ref22.children,
      rest = _objectWithoutProperties(_ref22, _excluded22);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M22 30H10V25H6l10-9 10 9H22zM16 16L6 7h4V2H22V7h4z"
  })), children);
});
var PressureFilled16 = /*#__PURE__*/React.forwardRef(function PressureFilled16(_ref23, ref) {
  var children = _ref23.children,
      rest = _objectWithoutProperties(_ref23, _excluded23);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M22 30H10V25H6l10-9 10 9H22zM16 16L6 7h4V2H22V7h4z"
  })), children);
});
var PreviousFilled32 = /*#__PURE__*/React.forwardRef(function PreviousFilled32(_ref24, ref) {
  var children = _ref24.children,
      rest = _objectWithoutProperties(_ref24, _excluded24);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm8,15H11.85l5.58,5.5728L16,24,8,16l8-8,1.43,1.3926L11.85,15H24Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M16 8L17.43 9.393 11.85 15 24 15 24 17 11.85 17 17.43 22.573 16 24 8 16 16 8z",
    "data-icon-path": "inner-path"
  })), children);
});
var PreviousFilled24 = /*#__PURE__*/React.forwardRef(function PreviousFilled24(_ref25, ref) {
  var children = _ref25.children,
      rest = _objectWithoutProperties(_ref25, _excluded25);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm8,15H11.85l5.58,5.5728L16,24,8,16l8-8,1.43,1.3926L11.85,15H24Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M16 8L17.43 9.393 11.85 15 24 15 24 17 11.85 17 17.43 22.573 16 24 8 16 16 8z",
    "data-icon-path": "inner-path"
  })), children);
});
var PreviousFilled20 = /*#__PURE__*/React.forwardRef(function PreviousFilled20(_ref26, ref) {
  var children = _ref26.children,
      rest = _objectWithoutProperties(_ref26, _excluded26);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm8,15H11.85l5.58,5.5728L16,24,8,16l8-8,1.43,1.3926L11.85,15H24Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M16 8L17.43 9.393 11.85 15 24 15 24 17 11.85 17 17.43 22.573 16 24 8 16 16 8z",
    "data-icon-path": "inner-path"
  })), children);
});
var PreviousFilled16 = /*#__PURE__*/React.forwardRef(function PreviousFilled16(_ref27, ref) {
  var children = _ref27.children,
      rest = _objectWithoutProperties(_ref27, _excluded27);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm8,15H11.85l5.58,5.5728L16,24,8,16l8-8,1.43,1.3926L11.85,15H24Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M16 8L17.43 9.393 11.85 15 24 15 24 17 11.85 17 17.43 22.573 16 24 8 16 16 8z",
    "data-icon-path": "inner-path"
  })), children);
});
var PreviousOutline32 = /*#__PURE__*/React.forwardRef(function PreviousOutline32(_ref28, ref) {
  var children = _ref28.children,
      rest = _objectWithoutProperties(_ref28, _excluded28);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8L17.43 9.393 11.85 15 24 15 24 17 11.85 17 17.43 22.573 16 24 8 16 16 8z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
});
var PreviousOutline24 = /*#__PURE__*/React.forwardRef(function PreviousOutline24(_ref29, ref) {
  var children = _ref29.children,
      rest = _objectWithoutProperties(_ref29, _excluded29);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8L17.43 9.393 11.85 15 24 15 24 17 11.85 17 17.43 22.573 16 24 8 16 16 8z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
});
var PreviousOutline20 = /*#__PURE__*/React.forwardRef(function PreviousOutline20(_ref30, ref) {
  var children = _ref30.children,
      rest = _objectWithoutProperties(_ref30, _excluded30);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8L17.43 9.393 11.85 15 24 15 24 17 11.85 17 17.43 22.573 16 24 8 16 16 8z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
});
var PreviousOutline16 = /*#__PURE__*/React.forwardRef(function PreviousOutline16(_ref31, ref) {
  var children = _ref31.children,
      rest = _objectWithoutProperties(_ref31, _excluded31);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8L17.43 9.393 11.85 15 24 15 24 17 11.85 17 17.43 22.573 16 24 8 16 16 8z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
});
var Printer32 = /*#__PURE__*/React.forwardRef(function Printer32(_ref32, ref) {
  var children = _ref32.children,
      rest = _objectWithoutProperties(_ref32, _excluded32);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M28,9H25V3H7V9H4a2,2,0,0,0-2,2V21a2,2,0,0,0,2,2H7v6H25V23h3a2,2,0,0,0,2-2V11A2,2,0,0,0,28,9ZM9,5H23V9H9ZM23,27H9V17H23Zm5-6H25V15H7v6H4V11H28Z"
  })), children);
});
var Printer24 = /*#__PURE__*/React.forwardRef(function Printer24(_ref33, ref) {
  var children = _ref33.children,
      rest = _objectWithoutProperties(_ref33, _excluded33);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M28,9H25V3H7V9H4a2,2,0,0,0-2,2V21a2,2,0,0,0,2,2H7v6H25V23h3a2,2,0,0,0,2-2V11A2,2,0,0,0,28,9ZM9,5H23V9H9ZM23,27H9V17H23Zm5-6H25V15H7v6H4V11H28Z"
  })), children);
});
var Printer20 = /*#__PURE__*/React.forwardRef(function Printer20(_ref34, ref) {
  var children = _ref34.children,
      rest = _objectWithoutProperties(_ref34, _excluded34);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M28,9H25V3H7V9H4a2,2,0,0,0-2,2V21a2,2,0,0,0,2,2H7v6H25V23h3a2,2,0,0,0,2-2V11A2,2,0,0,0,28,9ZM9,5H23V9H9ZM23,27H9V17H23Zm5-6H25V15H7v6H4V11H28Z"
  })), children);
});
var Printer16 = /*#__PURE__*/React.forwardRef(function Printer16(_ref35, ref) {
  var children = _ref35.children,
      rest = _objectWithoutProperties(_ref35, _excluded35);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M28,9H25V3H7V9H4a2,2,0,0,0-2,2V21a2,2,0,0,0,2,2H7v6H25V23h3a2,2,0,0,0,2-2V11A2,2,0,0,0,28,9ZM9,5H23V9H9ZM23,27H9V17H23Zm5-6H25V15H7v6H4V11H28Z"
  })), children);
});
var Product32 = /*#__PURE__*/React.forwardRef(function Product32(_ref36, ref) {
  var children = _ref36.children,
      rest = _objectWithoutProperties(_ref36, _excluded36);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M8 18H14V20H8zM8 22H18V24H8z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2.0025,2.0025,0,0,0,4,6V26a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V6A2.0025,2.0025,0,0,0,26,4ZM18,6v4H14V6ZM6,26V6h6v6h8V6h6l.0012,20Z"
  })), children);
});
var Product24 = /*#__PURE__*/React.forwardRef(function Product24(_ref37, ref) {
  var children = _ref37.children,
      rest = _objectWithoutProperties(_ref37, _excluded37);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M8 18H14V20H8zM8 22H18V24H8z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2.0025,2.0025,0,0,0,4,6V26a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V6A2.0025,2.0025,0,0,0,26,4ZM18,6v4H14V6ZM6,26V6h6v6h8V6h6l.0012,20Z"
  })), children);
});
var Product20 = /*#__PURE__*/React.forwardRef(function Product20(_ref38, ref) {
  var children = _ref38.children,
      rest = _objectWithoutProperties(_ref38, _excluded38);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M8 18H14V20H8zM8 22H18V24H8z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2.0025,2.0025,0,0,0,4,6V26a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V6A2.0025,2.0025,0,0,0,26,4ZM18,6v4H14V6ZM6,26V6h6v6h8V6h6l.0012,20Z"
  })), children);
});
var Product16 = /*#__PURE__*/React.forwardRef(function Product16(_ref39, ref) {
  var children = _ref39.children,
      rest = _objectWithoutProperties(_ref39, _excluded39);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M8 18H14V20H8zM8 22H18V24H8z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2.0025,2.0025,0,0,0,4,6V26a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V6A2.0025,2.0025,0,0,0,26,4ZM18,6v4H14V6ZM6,26V6h6v6h8V6h6l.0012,20Z"
  })), children);
});
var ProgressBar32 = /*#__PURE__*/React.forwardRef(function ProgressBar32(_ref40, ref) {
  var children = _ref40.children,
      rest = _objectWithoutProperties(_ref40, _excluded40);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M28,21H4a2.0021,2.0021,0,0,1-2-2V13a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,28,21ZM4,13v6H28V13Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M6 15H20V17H6z"
  })), children);
});
var ProgressBar24 = /*#__PURE__*/React.forwardRef(function ProgressBar24(_ref41, ref) {
  var children = _ref41.children,
      rest = _objectWithoutProperties(_ref41, _excluded41);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M28,21H4a2.0021,2.0021,0,0,1-2-2V13a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,28,21ZM4,13v6H28V13Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M6 15H20V17H6z"
  })), children);
});
var ProgressBar20 = /*#__PURE__*/React.forwardRef(function ProgressBar20(_ref42, ref) {
  var children = _ref42.children,
      rest = _objectWithoutProperties(_ref42, _excluded42);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M28,21H4a2.0021,2.0021,0,0,1-2-2V13a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,28,21ZM4,13v6H28V13Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M6 15H20V17H6z"
  })), children);
});
var ProgressBar16 = /*#__PURE__*/React.forwardRef(function ProgressBar16(_ref43, ref) {
  var children = _ref43.children,
      rest = _objectWithoutProperties(_ref43, _excluded43);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M28,21H4a2.0021,2.0021,0,0,1-2-2V13a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,28,21ZM4,13v6H28V13Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M6 15H20V17H6z"
  })), children);
});
var ProgressBarRound32 = /*#__PURE__*/React.forwardRef(function ProgressBarRound32(_ref44, ref) {
  var children = _ref44.children,
      rest = _objectWithoutProperties(_ref44, _excluded44);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M16,22a6,6,0,1,1,6-6A6.0067,6.0067,0,0,1,16,22Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,16,12Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M16,26a10.0162,10.0162,0,0,1-7.4531-3.3325l1.49-1.334A8,8,0,1,0,16,8V6a10,10,0,0,1,0,20Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
});
var ProgressBarRound24 = /*#__PURE__*/React.forwardRef(function ProgressBarRound24(_ref45, ref) {
  var children = _ref45.children,
      rest = _objectWithoutProperties(_ref45, _excluded45);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M16,22a6,6,0,1,1,6-6A6.0067,6.0067,0,0,1,16,22Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,16,12Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M16,26a10.0162,10.0162,0,0,1-7.4531-3.3325l1.49-1.334A8,8,0,1,0,16,8V6a10,10,0,0,1,0,20Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
});
var ProgressBarRound20 = /*#__PURE__*/React.forwardRef(function ProgressBarRound20(_ref46, ref) {
  var children = _ref46.children,
      rest = _objectWithoutProperties(_ref46, _excluded46);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M16,22a6,6,0,1,1,6-6A6.0067,6.0067,0,0,1,16,22Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,16,12Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M16,26a10.0162,10.0162,0,0,1-7.4531-3.3325l1.49-1.334A8,8,0,1,0,16,8V6a10,10,0,0,1,0,20Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
});
var ProgressBarRound16 = /*#__PURE__*/React.forwardRef(function ProgressBarRound16(_ref47, ref) {
  var children = _ref47.children,
      rest = _objectWithoutProperties(_ref47, _excluded47);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M16,22a6,6,0,1,1,6-6A6.0067,6.0067,0,0,1,16,22Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,16,12Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M16,26a10.0162,10.0162,0,0,1-7.4531-3.3325l1.49-1.334A8,8,0,1,0,16,8V6a10,10,0,0,1,0,20Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
});
var Purchase32 = /*#__PURE__*/React.forwardRef(function Purchase32(_ref48, ref) {
  var children = _ref48.children,
      rest = _objectWithoutProperties(_ref48, _excluded48);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6Zm0,2v3H4V8ZM4,24V13H28V24Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M6 20H16V22H6z"
  })), children);
});
var Purchase24 = /*#__PURE__*/React.forwardRef(function Purchase24(_ref49, ref) {
  var children = _ref49.children,
      rest = _objectWithoutProperties(_ref49, _excluded49);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6Zm0,2v3H4V8ZM4,24V13H28V24Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M6 20H16V22H6z"
  })), children);
});
var Purchase20 = /*#__PURE__*/React.forwardRef(function Purchase20(_ref50, ref) {
  var children = _ref50.children,
      rest = _objectWithoutProperties(_ref50, _excluded50);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6Zm0,2v3H4V8ZM4,24V13H28V24Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M6 20H16V22H6z"
  })), children);
});
var Purchase16 = /*#__PURE__*/React.forwardRef(function Purchase16(_ref51, ref) {
  var children = _ref51.children,
      rest = _objectWithoutProperties(_ref51, _excluded51);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6Zm0,2v3H4V8ZM4,24V13H28V24Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M6 20H16V22H6z"
  })), children);
});
var QqPlot32 = /*#__PURE__*/React.forwardRef(function QqPlot32(_ref52, ref) {
  var children = _ref52.children,
      rest = _objectWithoutProperties(_ref52, _excluded52);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "20",
    cy: "4",
    r: "2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "16",
    r: "2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: "28",
    cy: "12",
    r: "2"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "7",
    r: "2"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "24",
    r: "2"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M30,3.4131,28.5859,2,4,26.585V2H2V28a2,2,0,0,0,2,2H30V28H5.4131Z"
  })), children);
});
var QqPlot24 = /*#__PURE__*/React.forwardRef(function QqPlot24(_ref53, ref) {
  var children = _ref53.children,
      rest = _objectWithoutProperties(_ref53, _excluded53);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: "20",
    cy: "4",
    r: "2"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "16",
    r: "2"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: "28",
    cy: "12",
    r: "2"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "7",
    r: "2"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "24",
    r: "2"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M30,3.4131,28.5859,2,4,26.585V2H2V28a2,2,0,0,0,2,2H30V28H5.4131Z"
  })), children);
});
var QqPlot20 = /*#__PURE__*/React.forwardRef(function QqPlot20(_ref54, ref) {
  var children = _ref54.children,
      rest = _objectWithoutProperties(_ref54, _excluded54);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: "20",
    cy: "4",
    r: "2"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "16",
    r: "2"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: "28",
    cy: "12",
    r: "2"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "7",
    r: "2"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "24",
    r: "2"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M30,3.4131,28.5859,2,4,26.585V2H2V28a2,2,0,0,0,2,2H30V28H5.4131Z"
  })), children);
});
var QqPlot16 = /*#__PURE__*/React.forwardRef(function QqPlot16(_ref55, ref) {
  var children = _ref55.children,
      rest = _objectWithoutProperties(_ref55, _excluded55);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: "20",
    cy: "4",
    r: "2"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "16",
    r: "2"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: "28",
    cy: "12",
    r: "2"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "7",
    r: "2"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "24",
    r: "2"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M30,3.4131,28.5859,2,4,26.585V2H2V28a2,2,0,0,0,2,2H30V28H5.4131Z"
  })), children);
});
var QrCode32 = /*#__PURE__*/React.forwardRef(function QrCode32(_ref56, ref) {
  var children = _ref56.children,
      rest = _objectWithoutProperties(_ref56, _excluded56);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M24 26H26V28H24z",
    transform: "rotate(-90 25 27)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M18 22H20V24H18z",
    transform: "rotate(-90 19 23)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M18 30L22 30 22 28 20 28 20 26 18 26 18 30z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M25 23H29V25H25z",
    transform: "rotate(-90 27 24)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M28 26L30 26 30 30 26 30 26 28 28 28 28 26zM26 20L26 18 30 18 30 22 28 22 28 20 26 20zM24 20L22 20 22 24 20 24 20 26 24 26 24 20z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M19 17H21V21H19z",
    transform: "rotate(-90 20 19)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M6 22H10V26H6z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M14 30H2V18H14zM4 28h8V20H4zM22 6H26V10H22z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M30 14H18V2H30zM20 12h8V4H20zM6 6H10V10H6z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M14,14H2V2H14ZM4,12h8V4H4Z"
  })), children);
});
var QrCode24 = /*#__PURE__*/React.forwardRef(function QrCode24(_ref57, ref) {
  var children = _ref57.children,
      rest = _objectWithoutProperties(_ref57, _excluded57);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M24 26H26V28H24z",
    transform: "rotate(-90 25 27)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M18 22H20V24H18z",
    transform: "rotate(-90 19 23)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M18 30L22 30 22 28 20 28 20 26 18 26 18 30z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M25 23H29V25H25z",
    transform: "rotate(-90 27 24)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M28 26L30 26 30 30 26 30 26 28 28 28 28 26zM26 20L26 18 30 18 30 22 28 22 28 20 26 20zM24 20L22 20 22 24 20 24 20 26 24 26 24 20z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M19 17H21V21H19z",
    transform: "rotate(-90 20 19)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M6 22H10V26H6z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M14 30H2V18H14zM4 28h8V20H4zM22 6H26V10H22z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M30 14H18V2H30zM20 12h8V4H20zM6 6H10V10H6z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M14,14H2V2H14ZM4,12h8V4H4Z"
  })), children);
});
var QrCode20 = /*#__PURE__*/React.forwardRef(function QrCode20(_ref58, ref) {
  var children = _ref58.children,
      rest = _objectWithoutProperties(_ref58, _excluded58);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M24 26H26V28H24z",
    transform: "rotate(-90 25 27)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M18 22H20V24H18z",
    transform: "rotate(-90 19 23)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M18 30L22 30 22 28 20 28 20 26 18 26 18 30z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M25 23H29V25H25z",
    transform: "rotate(-90 27 24)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M28 26L30 26 30 30 26 30 26 28 28 28 28 26zM26 20L26 18 30 18 30 22 28 22 28 20 26 20zM24 20L22 20 22 24 20 24 20 26 24 26 24 20z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M19 17H21V21H19z",
    transform: "rotate(-90 20 19)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M6 22H10V26H6z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M14 30H2V18H14zM4 28h8V20H4zM22 6H26V10H22z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M30 14H18V2H30zM20 12h8V4H20zM6 6H10V10H6z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M14,14H2V2H14ZM4,12h8V4H4Z"
  })), children);
});
var QrCode16 = /*#__PURE__*/React.forwardRef(function QrCode16(_ref59, ref) {
  var children = _ref59.children,
      rest = _objectWithoutProperties(_ref59, _excluded59);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M24 26H26V28H24z",
    transform: "rotate(-90 25 27)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M18 22H20V24H18z",
    transform: "rotate(-90 19 23)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M18 30L22 30 22 28 20 28 20 26 18 26 18 30z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M25 23H29V25H25z",
    transform: "rotate(-90 27 24)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M28 26L30 26 30 30 26 30 26 28 28 28 28 26zM26 20L26 18 30 18 30 22 28 22 28 20 26 20zM24 20L22 20 22 24 20 24 20 26 24 26 24 20z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M19 17H21V21H19z",
    transform: "rotate(-90 20 19)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M6 22H10V26H6z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M14 30H2V18H14zM4 28h8V20H4zM22 6H26V10H22z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M30 14H18V2H30zM20 12h8V4H20zM6 6H10V10H6z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M14,14H2V2H14ZM4,12h8V4H4Z"
  })), children);
});
var QuadrantPlot32 = /*#__PURE__*/React.forwardRef(function QuadrantPlot32(_ref60, ref) {
  var children = _ref60.children,
      rest = _objectWithoutProperties(_ref60, _excluded60);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M30 15L17 15 17 2 15 2 15 15 2 15 2 17 15 17 15 30 17 30 17 17 30 17 30 15z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M5 30a3 3 0 113-3A3.0033 3.0033 0 015 30zm0-4a1 1 0 101 1A1.001 1.001 0 005 26zM8 8a3 3 0 113-3A3.0033 3.0033 0 018 8zM8 4A1 1 0 109 5 1.001 1.001 0 008 4zM22 13a3 3 0 113-3A3.0033 3.0033 0 0122 13zm0-4a1 1 0 101 1A1.001 1.001 0 0022 9z"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "11",
    r: "2"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "21",
    r: "2"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "21",
    r: "2"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "28",
    r: "2"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: "28",
    cy: "24",
    r: "2"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: "4",
    cy: "11",
    r: "2"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: "28",
    cy: "4",
    r: "2"
  })), children);
});
var QuadrantPlot24 = /*#__PURE__*/React.forwardRef(function QuadrantPlot24(_ref61, ref) {
  var children = _ref61.children,
      rest = _objectWithoutProperties(_ref61, _excluded61);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M30 15L17 15 17 2 15 2 15 15 2 15 2 17 15 17 15 30 17 30 17 17 30 17 30 15z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M5 30a3 3 0 113-3A3.0033 3.0033 0 015 30zm0-4a1 1 0 101 1A1.001 1.001 0 005 26zM8 8a3 3 0 113-3A3.0033 3.0033 0 018 8zM8 4A1 1 0 109 5 1.001 1.001 0 008 4zM22 13a3 3 0 113-3A3.0033 3.0033 0 0122 13zm0-4a1 1 0 101 1A1.001 1.001 0 0022 9z"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "11",
    r: "2"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "21",
    r: "2"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "21",
    r: "2"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "28",
    r: "2"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: "28",
    cy: "24",
    r: "2"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: "4",
    cy: "11",
    r: "2"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: "28",
    cy: "4",
    r: "2"
  })), children);
});
var QuadrantPlot20 = /*#__PURE__*/React.forwardRef(function QuadrantPlot20(_ref62, ref) {
  var children = _ref62.children,
      rest = _objectWithoutProperties(_ref62, _excluded62);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M30 15L17 15 17 2 15 2 15 15 2 15 2 17 15 17 15 30 17 30 17 17 30 17 30 15z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M5 30a3 3 0 113-3A3.0033 3.0033 0 015 30zm0-4a1 1 0 101 1A1.001 1.001 0 005 26zM8 8a3 3 0 113-3A3.0033 3.0033 0 018 8zM8 4A1 1 0 109 5 1.001 1.001 0 008 4zM22 13a3 3 0 113-3A3.0033 3.0033 0 0122 13zm0-4a1 1 0 101 1A1.001 1.001 0 0022 9z"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "11",
    r: "2"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "21",
    r: "2"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "21",
    r: "2"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "28",
    r: "2"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: "28",
    cy: "24",
    r: "2"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: "4",
    cy: "11",
    r: "2"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: "28",
    cy: "4",
    r: "2"
  })), children);
});
var QuadrantPlot16 = /*#__PURE__*/React.forwardRef(function QuadrantPlot16(_ref63, ref) {
  var children = _ref63.children,
      rest = _objectWithoutProperties(_ref63, _excluded63);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M30 15L17 15 17 2 15 2 15 15 2 15 2 17 15 17 15 30 17 30 17 17 30 17 30 15z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M5 30a3 3 0 113-3A3.0033 3.0033 0 015 30zm0-4a1 1 0 101 1A1.001 1.001 0 005 26zM8 8a3 3 0 113-3A3.0033 3.0033 0 018 8zM8 4A1 1 0 109 5 1.001 1.001 0 008 4zM22 13a3 3 0 113-3A3.0033 3.0033 0 0122 13zm0-4a1 1 0 101 1A1.001 1.001 0 0022 9z"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "11",
    r: "2"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "21",
    r: "2"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "21",
    r: "2"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "28",
    r: "2"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: "28",
    cy: "24",
    r: "2"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: "4",
    cy: "11",
    r: "2"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: "28",
    cy: "4",
    r: "2"
  })), children);
});
var Query32 = /*#__PURE__*/React.forwardRef(function Query32(_ref64, ref) {
  var children = _ref64.children,
      rest = _objectWithoutProperties(_ref64, _excluded64);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "15.5",
    r: "1.5"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M12,12H10V8h2a2,2,0,0,0,0-4H10A2.0023,2.0023,0,0,0,8,6v.5H6V6a4.0045,4.0045,0,0,1,4-4h2a4,4,0,0,1,0,8Z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4479,21.0337A10.971,10.971,0,0,0,19.9211,4.7446l-.999,1.73A8.9967,8.9967,0,1,1,5,14H3a10.9916,10.9916,0,0,0,18.0338,8.4478L28.5859,30,30,28.5859Z"
  })), children);
});
var Query24 = /*#__PURE__*/React.forwardRef(function Query24(_ref65, ref) {
  var children = _ref65.children,
      rest = _objectWithoutProperties(_ref65, _excluded65);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "15.5",
    r: "1.5"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M12,12H10V8h2a2,2,0,0,0,0-4H10A2.0023,2.0023,0,0,0,8,6v.5H6V6a4.0045,4.0045,0,0,1,4-4h2a4,4,0,0,1,0,8Z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4479,21.0337A10.971,10.971,0,0,0,19.9211,4.7446l-.999,1.73A8.9967,8.9967,0,1,1,5,14H3a10.9916,10.9916,0,0,0,18.0338,8.4478L28.5859,30,30,28.5859Z"
  })), children);
});
var Query20 = /*#__PURE__*/React.forwardRef(function Query20(_ref66, ref) {
  var children = _ref66.children,
      rest = _objectWithoutProperties(_ref66, _excluded66);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "15.5",
    r: "1.5"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M12,12H10V8h2a2,2,0,0,0,0-4H10A2.0023,2.0023,0,0,0,8,6v.5H6V6a4.0045,4.0045,0,0,1,4-4h2a4,4,0,0,1,0,8Z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4479,21.0337A10.971,10.971,0,0,0,19.9211,4.7446l-.999,1.73A8.9967,8.9967,0,1,1,5,14H3a10.9916,10.9916,0,0,0,18.0338,8.4478L28.5859,30,30,28.5859Z"
  })), children);
});
var Query16 = /*#__PURE__*/React.forwardRef(function Query16(_ref67, ref) {
  var children = _ref67.children,
      rest = _objectWithoutProperties(_ref67, _excluded67);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "15.5",
    r: "1.5"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M12,12H10V8h2a2,2,0,0,0,0-4H10A2.0023,2.0023,0,0,0,8,6v.5H6V6a4.0045,4.0045,0,0,1,4-4h2a4,4,0,0,1,0,8Z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4479,21.0337A10.971,10.971,0,0,0,19.9211,4.7446l-.999,1.73A8.9967,8.9967,0,1,1,5,14H3a10.9916,10.9916,0,0,0,18.0338,8.4478L28.5859,30,30,28.5859Z"
  })), children);
});
var QueryQueue32 = /*#__PURE__*/React.forwardRef(function QueryQueue32(_ref68, ref) {
  var children = _ref68.children,
      rest = _objectWithoutProperties(_ref68, _excluded68);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6H28V8H10zM10 12H28V14H10zM15 18H28V20H15zM10 24H28V26H10zM4 14L11 19 4 24 4 14z"
  })), children);
});
var QueryQueue24 = /*#__PURE__*/React.forwardRef(function QueryQueue24(_ref69, ref) {
  var children = _ref69.children,
      rest = _objectWithoutProperties(_ref69, _excluded69);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6H28V8H10zM10 12H28V14H10zM15 18H28V20H15zM10 24H28V26H10zM4 14L11 19 4 24 4 14z"
  })), children);
});
var QueryQueue20 = /*#__PURE__*/React.forwardRef(function QueryQueue20(_ref70, ref) {
  var children = _ref70.children,
      rest = _objectWithoutProperties(_ref70, _excluded70);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6H28V8H10zM10 12H28V14H10zM15 18H28V20H15zM10 24H28V26H10zM4 14L11 19 4 24 4 14z"
  })), children);
});
var QueryQueue16 = /*#__PURE__*/React.forwardRef(function QueryQueue16(_ref71, ref) {
  var children = _ref71.children,
      rest = _objectWithoutProperties(_ref71, _excluded71);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6H28V8H10zM10 12H28V14H10zM15 18H28V20H15zM10 24H28V26H10zM4 14L11 19 4 24 4 14z"
  })), children);
});
var Queued32 = /*#__PURE__*/React.forwardRef(function Queued32(_ref72, ref) {
  var children = _ref72.children,
      rest = _objectWithoutProperties(_ref72, _excluded72);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M22 20H30V22H22zM22 24H30V26H22zM22 28H30V30H22zM18 24H20V26H18zM18 20H20V22H18zM18 28H20V30H18zM6.8149 8.293A12.0777 12.0777 0 0110.0068 5.62L9.0079 3.89A14.0845 14.0845 0 005.2841 7.0083zM25.1851 8.293l1.5308-1.2847A14.0845 14.0845 0 0022.9921 3.89l-.9989 1.73A12.0777 12.0777 0 0125.1851 8.293zM4.7366 11.9l-1.8772-.6831A13.9019 13.9019 0 002 16H4A11.917 11.917 0 014.7366 11.9zM6.8149 23.707A11.9975 11.9975 0 014.7366 20.1l-1.8772.6831a13.99 13.99 0 002.4247 4.209zM27.2634 11.9A11.917 11.917 0 0128 16h2a13.8971 13.8971 0 00-.8594-4.7827zM13.9182 27.8066A11.8894 11.8894 0 0110.0068 26.38l-.9989 1.73a13.8673 13.8673 0 004.5633 1.664zM13.9182 4.1934a11.3012 11.3012 0 014.1636 0l.347-1.9678a13.187 13.187 0 00-4.8576 0z"
  })), children);
});
var Queued24 = /*#__PURE__*/React.forwardRef(function Queued24(_ref73, ref) {
  var children = _ref73.children,
      rest = _objectWithoutProperties(_ref73, _excluded73);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M22 20H30V22H22zM22 24H30V26H22zM22 28H30V30H22zM18 24H20V26H18zM18 20H20V22H18zM18 28H20V30H18zM6.8149 8.293A12.0777 12.0777 0 0110.0068 5.62L9.0079 3.89A14.0845 14.0845 0 005.2841 7.0083zM25.1851 8.293l1.5308-1.2847A14.0845 14.0845 0 0022.9921 3.89l-.9989 1.73A12.0777 12.0777 0 0125.1851 8.293zM4.7366 11.9l-1.8772-.6831A13.9019 13.9019 0 002 16H4A11.917 11.917 0 014.7366 11.9zM6.8149 23.707A11.9975 11.9975 0 014.7366 20.1l-1.8772.6831a13.99 13.99 0 002.4247 4.209zM27.2634 11.9A11.917 11.917 0 0128 16h2a13.8971 13.8971 0 00-.8594-4.7827zM13.9182 27.8066A11.8894 11.8894 0 0110.0068 26.38l-.9989 1.73a13.8673 13.8673 0 004.5633 1.664zM13.9182 4.1934a11.3012 11.3012 0 014.1636 0l.347-1.9678a13.187 13.187 0 00-4.8576 0z"
  })), children);
});
var Queued20 = /*#__PURE__*/React.forwardRef(function Queued20(_ref74, ref) {
  var children = _ref74.children,
      rest = _objectWithoutProperties(_ref74, _excluded74);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M22 20H30V22H22zM22 24H30V26H22zM22 28H30V30H22zM18 24H20V26H18zM18 20H20V22H18zM18 28H20V30H18zM6.8149 8.293A12.0777 12.0777 0 0110.0068 5.62L9.0079 3.89A14.0845 14.0845 0 005.2841 7.0083zM25.1851 8.293l1.5308-1.2847A14.0845 14.0845 0 0022.9921 3.89l-.9989 1.73A12.0777 12.0777 0 0125.1851 8.293zM4.7366 11.9l-1.8772-.6831A13.9019 13.9019 0 002 16H4A11.917 11.917 0 014.7366 11.9zM6.8149 23.707A11.9975 11.9975 0 014.7366 20.1l-1.8772.6831a13.99 13.99 0 002.4247 4.209zM27.2634 11.9A11.917 11.917 0 0128 16h2a13.8971 13.8971 0 00-.8594-4.7827zM13.9182 27.8066A11.8894 11.8894 0 0110.0068 26.38l-.9989 1.73a13.8673 13.8673 0 004.5633 1.664zM13.9182 4.1934a11.3012 11.3012 0 014.1636 0l.347-1.9678a13.187 13.187 0 00-4.8576 0z"
  })), children);
});
var Queued16 = /*#__PURE__*/React.forwardRef(function Queued16(_ref75, ref) {
  var children = _ref75.children,
      rest = _objectWithoutProperties(_ref75, _excluded75);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M22 20H30V22H22zM22 24H30V26H22zM22 28H30V30H22zM18 24H20V26H18zM18 20H20V22H18zM18 28H20V30H18zM6.8149 8.293A12.0777 12.0777 0 0110.0068 5.62L9.0079 3.89A14.0845 14.0845 0 005.2841 7.0083zM25.1851 8.293l1.5308-1.2847A14.0845 14.0845 0 0022.9921 3.89l-.9989 1.73A12.0777 12.0777 0 0125.1851 8.293zM4.7366 11.9l-1.8772-.6831A13.9019 13.9019 0 002 16H4A11.917 11.917 0 014.7366 11.9zM6.8149 23.707A11.9975 11.9975 0 014.7366 20.1l-1.8772.6831a13.99 13.99 0 002.4247 4.209zM27.2634 11.9A11.917 11.917 0 0128 16h2a13.8971 13.8971 0 00-.8594-4.7827zM13.9182 27.8066A11.8894 11.8894 0 0110.0068 26.38l-.9989 1.73a13.8673 13.8673 0 004.5633 1.664zM13.9182 4.1934a11.3012 11.3012 0 014.1636 0l.347-1.9678a13.187 13.187 0 00-4.8576 0z"
  })), children);
});
var Quotes32 = /*#__PURE__*/React.forwardRef(function Quotes32(_ref76, ref) {
  var children = _ref76.children,
      rest = _objectWithoutProperties(_ref76, _excluded76);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15H6.11A9 9 0 0110 8.86l1.79-1.2L10.69 6 8.9 7.2A11 11 0 004 16.35V23a2 2 0 002 2h6a2 2 0 002-2V17A2 2 0 0012 15zM26 15H20.11A9 9 0 0124 8.86l1.79-1.2L24.7 6 22.9 7.2A11 11 0 0018 16.35V23a2 2 0 002 2h6a2 2 0 002-2V17A2 2 0 0026 15z"
  })), children);
});
var Quotes24 = /*#__PURE__*/React.forwardRef(function Quotes24(_ref77, ref) {
  var children = _ref77.children,
      rest = _objectWithoutProperties(_ref77, _excluded77);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15H6.11A9 9 0 0110 8.86l1.79-1.2L10.69 6 8.9 7.2A11 11 0 004 16.35V23a2 2 0 002 2h6a2 2 0 002-2V17A2 2 0 0012 15zM26 15H20.11A9 9 0 0124 8.86l1.79-1.2L24.7 6 22.9 7.2A11 11 0 0018 16.35V23a2 2 0 002 2h6a2 2 0 002-2V17A2 2 0 0026 15z"
  })), children);
});
var Quotes20 = /*#__PURE__*/React.forwardRef(function Quotes20(_ref78, ref) {
  var children = _ref78.children,
      rest = _objectWithoutProperties(_ref78, _excluded78);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15H6.11A9 9 0 0110 8.86l1.79-1.2L10.69 6 8.9 7.2A11 11 0 004 16.35V23a2 2 0 002 2h6a2 2 0 002-2V17A2 2 0 0012 15zM26 15H20.11A9 9 0 0124 8.86l1.79-1.2L24.7 6 22.9 7.2A11 11 0 0018 16.35V23a2 2 0 002 2h6a2 2 0 002-2V17A2 2 0 0026 15z"
  })), children);
});
var Quotes16 = /*#__PURE__*/React.forwardRef(function Quotes16(_ref79, ref) {
  var children = _ref79.children,
      rest = _objectWithoutProperties(_ref79, _excluded79);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15H6.11A9 9 0 0110 8.86l1.79-1.2L10.69 6 8.9 7.2A11 11 0 004 16.35V23a2 2 0 002 2h6a2 2 0 002-2V17A2 2 0 0012 15zM26 15H20.11A9 9 0 0124 8.86l1.79-1.2L24.7 6 22.9 7.2A11 11 0 0018 16.35V23a2 2 0 002 2h6a2 2 0 002-2V17A2 2 0 0026 15z"
  })), children);
});
var Radar32 = /*#__PURE__*/React.forwardRef(function Radar32(_ref80, ref) {
  var children = _ref80.children,
      rest = _objectWithoutProperties(_ref80, _excluded80);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M30,3.4141,28.5859,2,15.293,15.293a1,1,0,0,0,1.414,1.414l4.18-4.1792A5.9956,5.9956,0,1,1,16,10V8a8.011,8.011,0,1,0,6.3164,3.0977L25.1631,8.251A11.881,11.881,0,0,1,28,16,12,12,0,1,1,16,4V2A14,14,0,1,0,30,16a13.8572,13.8572,0,0,0-3.4224-9.1636Z"
  })), children);
});
var Radar24 = /*#__PURE__*/React.forwardRef(function Radar24(_ref81, ref) {
  var children = _ref81.children,
      rest = _objectWithoutProperties(_ref81, _excluded81);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M30,3.4141,28.5859,2,15.293,15.293a1,1,0,0,0,1.414,1.414l4.18-4.1792A5.9956,5.9956,0,1,1,16,10V8a8.011,8.011,0,1,0,6.3164,3.0977L25.1631,8.251A11.881,11.881,0,0,1,28,16,12,12,0,1,1,16,4V2A14,14,0,1,0,30,16a13.8572,13.8572,0,0,0-3.4224-9.1636Z"
  })), children);
});
var Radar20 = /*#__PURE__*/React.forwardRef(function Radar20(_ref82, ref) {
  var children = _ref82.children,
      rest = _objectWithoutProperties(_ref82, _excluded82);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M30,3.4141,28.5859,2,15.293,15.293a1,1,0,0,0,1.414,1.414l4.18-4.1792A5.9956,5.9956,0,1,1,16,10V8a8.011,8.011,0,1,0,6.3164,3.0977L25.1631,8.251A11.881,11.881,0,0,1,28,16,12,12,0,1,1,16,4V2A14,14,0,1,0,30,16a13.8572,13.8572,0,0,0-3.4224-9.1636Z"
  })), children);
});
var Radar16 = /*#__PURE__*/React.forwardRef(function Radar16(_ref83, ref) {
  var children = _ref83.children,
      rest = _objectWithoutProperties(_ref83, _excluded83);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M30,3.4141,28.5859,2,15.293,15.293a1,1,0,0,0,1.414,1.414l4.18-4.1792A5.9956,5.9956,0,1,1,16,10V8a8.011,8.011,0,1,0,6.3164,3.0977L25.1631,8.251A11.881,11.881,0,0,1,28,16,12,12,0,1,1,16,4V2A14,14,0,1,0,30,16a13.8572,13.8572,0,0,0-3.4224-9.1636Z"
  })), children);
});
var RadarEnhanced32 = /*#__PURE__*/React.forwardRef(function RadarEnhanced32(_ref84, ref) {
  var children = _ref84.children,
      rest = _objectWithoutProperties(_ref84, _excluded84);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M30,3.4146,28.5854,2,17.2932,13.2925a1,1,0,1,0,1.4141,1.414l3.4543-3.4541A4.9817,4.9817,0,0,1,18,19a5.0385,5.0385,0,0,1-.6074-.05,8.0432,8.0432,0,0,0-4.3421-4.3423A4.9,4.9,0,0,1,18,9V7a7.0078,7.0078,0,0,0-7,7c0,.0234.0056.0469.0059.07A8.0469,8.0469,0,0,0,10,14a7.95,7.95,0,0,0-1.9883.26C8.0095,14.1729,8,14.0879,8,14A10.0114,10.0114,0,0,1,18,4V2A12.0137,12.0137,0,0,0,6,14c0,.355.0171.7061.0471,1.0537A7.9943,7.9943,0,1,0,16.9465,25.9521c.35.03.7019.0479,1.0535.0479A11.9853,11.9853,0,0,0,27.1538,6.2607ZM15.91,21H13.9563a12.029,12.029,0,0,0-1.218-4.332A6.01,6.01,0,0,1,15.91,21ZM4.09,23H6.0435a12.0318,12.0318,0,0,0,1.2182,4.3325A6.01,6.01,0,0,1,4.09,23Zm1.9532-2H4.09a6.01,6.01,0,0,1,3.1714-4.332A12.0321,12.0321,0,0,0,6.0435,21ZM10,27.9858A10.0149,10.0149,0,0,1,8.0552,23h3.89A10.0149,10.0149,0,0,1,10,27.9858ZM8.0552,21A10.0118,10.0118,0,0,1,10,16.0151,10.01,10.01,0,0,1,11.9448,21Zm4.6831,6.3325A12.0318,12.0318,0,0,0,13.9565,23H15.91A6.01,6.01,0,0,1,12.7383,27.3325ZM28,14A10.0114,10.0114,0,0,1,18,24c-.0869,0-.1733-.01-.26-.0117a7.5527,7.5527,0,0,0,.19-2.9942c.0237,0,.0466.0059.07.0059A6.9991,6.9991,0,0,0,23.6055,9.8086l2.1313-2.1314A9.95,9.95,0,0,1,28,14Z"
  })), children);
});
var RadarEnhanced24 = /*#__PURE__*/React.forwardRef(function RadarEnhanced24(_ref85, ref) {
  var children = _ref85.children,
      rest = _objectWithoutProperties(_ref85, _excluded85);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M30,3.4146,28.5854,2,17.2932,13.2925a1,1,0,1,0,1.4141,1.414l3.4543-3.4541A4.9817,4.9817,0,0,1,18,19a5.0385,5.0385,0,0,1-.6074-.05,8.0432,8.0432,0,0,0-4.3421-4.3423A4.9,4.9,0,0,1,18,9V7a7.0078,7.0078,0,0,0-7,7c0,.0234.0056.0469.0059.07A8.0469,8.0469,0,0,0,10,14a7.95,7.95,0,0,0-1.9883.26C8.0095,14.1729,8,14.0879,8,14A10.0114,10.0114,0,0,1,18,4V2A12.0137,12.0137,0,0,0,6,14c0,.355.0171.7061.0471,1.0537A7.9943,7.9943,0,1,0,16.9465,25.9521c.35.03.7019.0479,1.0535.0479A11.9853,11.9853,0,0,0,27.1538,6.2607ZM15.91,21H13.9563a12.029,12.029,0,0,0-1.218-4.332A6.01,6.01,0,0,1,15.91,21ZM4.09,23H6.0435a12.0318,12.0318,0,0,0,1.2182,4.3325A6.01,6.01,0,0,1,4.09,23Zm1.9532-2H4.09a6.01,6.01,0,0,1,3.1714-4.332A12.0321,12.0321,0,0,0,6.0435,21ZM10,27.9858A10.0149,10.0149,0,0,1,8.0552,23h3.89A10.0149,10.0149,0,0,1,10,27.9858ZM8.0552,21A10.0118,10.0118,0,0,1,10,16.0151,10.01,10.01,0,0,1,11.9448,21Zm4.6831,6.3325A12.0318,12.0318,0,0,0,13.9565,23H15.91A6.01,6.01,0,0,1,12.7383,27.3325ZM28,14A10.0114,10.0114,0,0,1,18,24c-.0869,0-.1733-.01-.26-.0117a7.5527,7.5527,0,0,0,.19-2.9942c.0237,0,.0466.0059.07.0059A6.9991,6.9991,0,0,0,23.6055,9.8086l2.1313-2.1314A9.95,9.95,0,0,1,28,14Z"
  })), children);
});
var RadarEnhanced20 = /*#__PURE__*/React.forwardRef(function RadarEnhanced20(_ref86, ref) {
  var children = _ref86.children,
      rest = _objectWithoutProperties(_ref86, _excluded86);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M30,3.4146,28.5854,2,17.2932,13.2925a1,1,0,1,0,1.4141,1.414l3.4543-3.4541A4.9817,4.9817,0,0,1,18,19a5.0385,5.0385,0,0,1-.6074-.05,8.0432,8.0432,0,0,0-4.3421-4.3423A4.9,4.9,0,0,1,18,9V7a7.0078,7.0078,0,0,0-7,7c0,.0234.0056.0469.0059.07A8.0469,8.0469,0,0,0,10,14a7.95,7.95,0,0,0-1.9883.26C8.0095,14.1729,8,14.0879,8,14A10.0114,10.0114,0,0,1,18,4V2A12.0137,12.0137,0,0,0,6,14c0,.355.0171.7061.0471,1.0537A7.9943,7.9943,0,1,0,16.9465,25.9521c.35.03.7019.0479,1.0535.0479A11.9853,11.9853,0,0,0,27.1538,6.2607ZM15.91,21H13.9563a12.029,12.029,0,0,0-1.218-4.332A6.01,6.01,0,0,1,15.91,21ZM4.09,23H6.0435a12.0318,12.0318,0,0,0,1.2182,4.3325A6.01,6.01,0,0,1,4.09,23Zm1.9532-2H4.09a6.01,6.01,0,0,1,3.1714-4.332A12.0321,12.0321,0,0,0,6.0435,21ZM10,27.9858A10.0149,10.0149,0,0,1,8.0552,23h3.89A10.0149,10.0149,0,0,1,10,27.9858ZM8.0552,21A10.0118,10.0118,0,0,1,10,16.0151,10.01,10.01,0,0,1,11.9448,21Zm4.6831,6.3325A12.0318,12.0318,0,0,0,13.9565,23H15.91A6.01,6.01,0,0,1,12.7383,27.3325ZM28,14A10.0114,10.0114,0,0,1,18,24c-.0869,0-.1733-.01-.26-.0117a7.5527,7.5527,0,0,0,.19-2.9942c.0237,0,.0466.0059.07.0059A6.9991,6.9991,0,0,0,23.6055,9.8086l2.1313-2.1314A9.95,9.95,0,0,1,28,14Z"
  })), children);
});
var RadarEnhanced16 = /*#__PURE__*/React.forwardRef(function RadarEnhanced16(_ref87, ref) {
  var children = _ref87.children,
      rest = _objectWithoutProperties(_ref87, _excluded87);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M30,3.4146,28.5854,2,17.2932,13.2925a1,1,0,1,0,1.4141,1.414l3.4543-3.4541A4.9817,4.9817,0,0,1,18,19a5.0385,5.0385,0,0,1-.6074-.05,8.0432,8.0432,0,0,0-4.3421-4.3423A4.9,4.9,0,0,1,18,9V7a7.0078,7.0078,0,0,0-7,7c0,.0234.0056.0469.0059.07A8.0469,8.0469,0,0,0,10,14a7.95,7.95,0,0,0-1.9883.26C8.0095,14.1729,8,14.0879,8,14A10.0114,10.0114,0,0,1,18,4V2A12.0137,12.0137,0,0,0,6,14c0,.355.0171.7061.0471,1.0537A7.9943,7.9943,0,1,0,16.9465,25.9521c.35.03.7019.0479,1.0535.0479A11.9853,11.9853,0,0,0,27.1538,6.2607ZM15.91,21H13.9563a12.029,12.029,0,0,0-1.218-4.332A6.01,6.01,0,0,1,15.91,21ZM4.09,23H6.0435a12.0318,12.0318,0,0,0,1.2182,4.3325A6.01,6.01,0,0,1,4.09,23Zm1.9532-2H4.09a6.01,6.01,0,0,1,3.1714-4.332A12.0321,12.0321,0,0,0,6.0435,21ZM10,27.9858A10.0149,10.0149,0,0,1,8.0552,23h3.89A10.0149,10.0149,0,0,1,10,27.9858ZM8.0552,21A10.0118,10.0118,0,0,1,10,16.0151,10.01,10.01,0,0,1,11.9448,21Zm4.6831,6.3325A12.0318,12.0318,0,0,0,13.9565,23H15.91A6.01,6.01,0,0,1,12.7383,27.3325ZM28,14A10.0114,10.0114,0,0,1,18,24c-.0869,0-.1733-.01-.26-.0117a7.5527,7.5527,0,0,0,.19-2.9942c.0237,0,.0466.0059.07.0059A6.9991,6.9991,0,0,0,23.6055,9.8086l2.1313-2.1314A9.95,9.95,0,0,1,28,14Z"
  })), children);
});
var RadarWeather32 = /*#__PURE__*/React.forwardRef(function RadarWeather32(_ref88, ref) {
  var children = _ref88.children,
      rest = _objectWithoutProperties(_ref88, _excluded88);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M30,3.4146,28.5854,2,17.2932,13.2925a1,1,0,1,0,1.4141,1.414l3.4543-3.4541a4.9646,4.9646,0,0,1-3.8811,7.7193,7.0485,7.0485,0,0,0-5.1438-3.8731A4.9431,4.9431,0,0,1,18,9V7a6.9551,6.9551,0,0,0-6.9087,8.0791,6.93,6.93,0,0,0-2.8525,1.06A9.97,9.97,0,0,1,18,4V2A11.9756,11.9756,0,0,0,6.573,17.6357a6.9293,6.9293,0,0,0-1.3674,2.7061A4.9948,4.9948,0,0,0,7,30H17a4.9921,4.9921,0,0,0,4.9678-4.68A12.0391,12.0391,0,0,0,30,14a11.8678,11.8678,0,0,0-2.8389-7.7466ZM17,28H7a2.9945,2.9945,0,0,1-.6963-5.9082l.6587-.1572.0986-.67a4.9923,4.9923,0,0,1,9.878,0l.0986.6695.6587.1572A2.9945,2.9945,0,0,1,17,28ZM28,14a10.0346,10.0346,0,0,1-6.3118,9.291,4.9577,4.9577,0,0,0-2.0207-2.5,6.9922,6.9922,0,0,0,3.938-10.9824l2.132-2.1318A9.8873,9.8873,0,0,1,28,14Z"
  })), children);
});
var RadarWeather24 = /*#__PURE__*/React.forwardRef(function RadarWeather24(_ref89, ref) {
  var children = _ref89.children,
      rest = _objectWithoutProperties(_ref89, _excluded89);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M30,3.4146,28.5854,2,17.2932,13.2925a1,1,0,1,0,1.4141,1.414l3.4543-3.4541a4.9646,4.9646,0,0,1-3.8811,7.7193,7.0485,7.0485,0,0,0-5.1438-3.8731A4.9431,4.9431,0,0,1,18,9V7a6.9551,6.9551,0,0,0-6.9087,8.0791,6.93,6.93,0,0,0-2.8525,1.06A9.97,9.97,0,0,1,18,4V2A11.9756,11.9756,0,0,0,6.573,17.6357a6.9293,6.9293,0,0,0-1.3674,2.7061A4.9948,4.9948,0,0,0,7,30H17a4.9921,4.9921,0,0,0,4.9678-4.68A12.0391,12.0391,0,0,0,30,14a11.8678,11.8678,0,0,0-2.8389-7.7466ZM17,28H7a2.9945,2.9945,0,0,1-.6963-5.9082l.6587-.1572.0986-.67a4.9923,4.9923,0,0,1,9.878,0l.0986.6695.6587.1572A2.9945,2.9945,0,0,1,17,28ZM28,14a10.0346,10.0346,0,0,1-6.3118,9.291,4.9577,4.9577,0,0,0-2.0207-2.5,6.9922,6.9922,0,0,0,3.938-10.9824l2.132-2.1318A9.8873,9.8873,0,0,1,28,14Z"
  })), children);
});
var RadarWeather20 = /*#__PURE__*/React.forwardRef(function RadarWeather20(_ref90, ref) {
  var children = _ref90.children,
      rest = _objectWithoutProperties(_ref90, _excluded90);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M30,3.4146,28.5854,2,17.2932,13.2925a1,1,0,1,0,1.4141,1.414l3.4543-3.4541a4.9646,4.9646,0,0,1-3.8811,7.7193,7.0485,7.0485,0,0,0-5.1438-3.8731A4.9431,4.9431,0,0,1,18,9V7a6.9551,6.9551,0,0,0-6.9087,8.0791,6.93,6.93,0,0,0-2.8525,1.06A9.97,9.97,0,0,1,18,4V2A11.9756,11.9756,0,0,0,6.573,17.6357a6.9293,6.9293,0,0,0-1.3674,2.7061A4.9948,4.9948,0,0,0,7,30H17a4.9921,4.9921,0,0,0,4.9678-4.68A12.0391,12.0391,0,0,0,30,14a11.8678,11.8678,0,0,0-2.8389-7.7466ZM17,28H7a2.9945,2.9945,0,0,1-.6963-5.9082l.6587-.1572.0986-.67a4.9923,4.9923,0,0,1,9.878,0l.0986.6695.6587.1572A2.9945,2.9945,0,0,1,17,28ZM28,14a10.0346,10.0346,0,0,1-6.3118,9.291,4.9577,4.9577,0,0,0-2.0207-2.5,6.9922,6.9922,0,0,0,3.938-10.9824l2.132-2.1318A9.8873,9.8873,0,0,1,28,14Z"
  })), children);
});
var RadarWeather16 = /*#__PURE__*/React.forwardRef(function RadarWeather16(_ref91, ref) {
  var children = _ref91.children,
      rest = _objectWithoutProperties(_ref91, _excluded91);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M30,3.4146,28.5854,2,17.2932,13.2925a1,1,0,1,0,1.4141,1.414l3.4543-3.4541a4.9646,4.9646,0,0,1-3.8811,7.7193,7.0485,7.0485,0,0,0-5.1438-3.8731A4.9431,4.9431,0,0,1,18,9V7a6.9551,6.9551,0,0,0-6.9087,8.0791,6.93,6.93,0,0,0-2.8525,1.06A9.97,9.97,0,0,1,18,4V2A11.9756,11.9756,0,0,0,6.573,17.6357a6.9293,6.9293,0,0,0-1.3674,2.7061A4.9948,4.9948,0,0,0,7,30H17a4.9921,4.9921,0,0,0,4.9678-4.68A12.0391,12.0391,0,0,0,30,14a11.8678,11.8678,0,0,0-2.8389-7.7466ZM17,28H7a2.9945,2.9945,0,0,1-.6963-5.9082l.6587-.1572.0986-.67a4.9923,4.9923,0,0,1,9.878,0l.0986.6695.6587.1572A2.9945,2.9945,0,0,1,17,28ZM28,14a10.0346,10.0346,0,0,1-6.3118,9.291,4.9577,4.9577,0,0,0-2.0207-2.5,6.9922,6.9922,0,0,0,3.938-10.9824l2.132-2.1318A9.8873,9.8873,0,0,1,28,14Z"
  })), children);
});
var Radio32 = /*#__PURE__*/React.forwardRef(function Radio32(_ref92, ref) {
  var children = _ref92.children,
      rest = _objectWithoutProperties(_ref92, _excluded92);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M28,10H24V2H22v8H13V8H11v2H8V8H6v2H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10ZM4,28V12H28V28Z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M10 26a4 4 0 114-4A4 4 0 0110 26zm0-6a2 2 0 102 2A2 2 0 0010 20zM7 14H13V16H7zM17 16H26V18H17zM17 20H26V22H17zM17 24H26V26H17z"
  })), children);
});
var Radio24 = /*#__PURE__*/React.forwardRef(function Radio24(_ref93, ref) {
  var children = _ref93.children,
      rest = _objectWithoutProperties(_ref93, _excluded93);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M28,10H24V2H22v8H13V8H11v2H8V8H6v2H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10ZM4,28V12H28V28Z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M10 26a4 4 0 114-4A4 4 0 0110 26zm0-6a2 2 0 102 2A2 2 0 0010 20zM7 14H13V16H7zM17 16H26V18H17zM17 20H26V22H17zM17 24H26V26H17z"
  })), children);
});
var Radio20 = /*#__PURE__*/React.forwardRef(function Radio20(_ref94, ref) {
  var children = _ref94.children,
      rest = _objectWithoutProperties(_ref94, _excluded94);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M28,10H24V2H22v8H13V8H11v2H8V8H6v2H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10ZM4,28V12H28V28Z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M10 26a4 4 0 114-4A4 4 0 0110 26zm0-6a2 2 0 102 2A2 2 0 0010 20zM7 14H13V16H7zM17 16H26V18H17zM17 20H26V22H17zM17 24H26V26H17z"
  })), children);
});
var Radio16 = /*#__PURE__*/React.forwardRef(function Radio16(_ref95, ref) {
  var children = _ref95.children,
      rest = _objectWithoutProperties(_ref95, _excluded95);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M28,10H24V2H22v8H13V8H11v2H8V8H6v2H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10ZM4,28V12H28V28Z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M10 26a4 4 0 114-4A4 4 0 0110 26zm0-6a2 2 0 102 2A2 2 0 0010 20zM7 14H13V16H7zM17 16H26V18H17zM17 20H26V22H17zM17 24H26V26H17z"
  })), children);
});
var RadioCombat32 = /*#__PURE__*/React.forwardRef(function RadioCombat32(_ref96, ref) {
  var children = _ref96.children,
      rest = _objectWithoutProperties(_ref96, _excluded96);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M10 26a4 4 0 114-4A4.0045 4.0045 0 0110 26zm0-6a2 2 0 102 2A2.0021 2.0021 0 0010 20zM17 20H26V22H17zM17 24H26V26H17z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M20,12h8a2.0023,2.0023,0,0,0,2-2V6a2.0023,2.0023,0,0,0-2-2H20a2.0023,2.0023,0,0,0-2,2V7H12a4.0045,4.0045,0,0,0-4,4v3H6V4H4V14a2.0023,2.0023,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V16a2.0023,2.0023,0,0,0-2-2H10V11a2.0023,2.0023,0,0,1,2-2h6v1A2.0023,2.0023,0,0,0,20,12Zm4-6h4v4H24ZM20,6h2v4H20Zm8,22H4V16H28Z"
  })), children);
});
var RadioCombat24 = /*#__PURE__*/React.forwardRef(function RadioCombat24(_ref97, ref) {
  var children = _ref97.children,
      rest = _objectWithoutProperties(_ref97, _excluded97);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M10 26a4 4 0 114-4A4.0045 4.0045 0 0110 26zm0-6a2 2 0 102 2A2.0021 2.0021 0 0010 20zM17 20H26V22H17zM17 24H26V26H17z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M20,12h8a2.0023,2.0023,0,0,0,2-2V6a2.0023,2.0023,0,0,0-2-2H20a2.0023,2.0023,0,0,0-2,2V7H12a4.0045,4.0045,0,0,0-4,4v3H6V4H4V14a2.0023,2.0023,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V16a2.0023,2.0023,0,0,0-2-2H10V11a2.0023,2.0023,0,0,1,2-2h6v1A2.0023,2.0023,0,0,0,20,12Zm4-6h4v4H24ZM20,6h2v4H20Zm8,22H4V16H28Z"
  })), children);
});
var RadioCombat20 = /*#__PURE__*/React.forwardRef(function RadioCombat20(_ref98, ref) {
  var children = _ref98.children,
      rest = _objectWithoutProperties(_ref98, _excluded98);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M10 26a4 4 0 114-4A4.0045 4.0045 0 0110 26zm0-6a2 2 0 102 2A2.0021 2.0021 0 0010 20zM17 20H26V22H17zM17 24H26V26H17z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M20,12h8a2.0023,2.0023,0,0,0,2-2V6a2.0023,2.0023,0,0,0-2-2H20a2.0023,2.0023,0,0,0-2,2V7H12a4.0045,4.0045,0,0,0-4,4v3H6V4H4V14a2.0023,2.0023,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V16a2.0023,2.0023,0,0,0-2-2H10V11a2.0023,2.0023,0,0,1,2-2h6v1A2.0023,2.0023,0,0,0,20,12Zm4-6h4v4H24ZM20,6h2v4H20Zm8,22H4V16H28Z"
  })), children);
});
var RadioCombat16 = /*#__PURE__*/React.forwardRef(function RadioCombat16(_ref99, ref) {
  var children = _ref99.children,
      rest = _objectWithoutProperties(_ref99, _excluded99);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M10 26a4 4 0 114-4A4.0045 4.0045 0 0110 26zm0-6a2 2 0 102 2A2.0021 2.0021 0 0010 20zM17 20H26V22H17zM17 24H26V26H17z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M20,12h8a2.0023,2.0023,0,0,0,2-2V6a2.0023,2.0023,0,0,0-2-2H20a2.0023,2.0023,0,0,0-2,2V7H12a4.0045,4.0045,0,0,0-4,4v3H6V4H4V14a2.0023,2.0023,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V16a2.0023,2.0023,0,0,0-2-2H10V11a2.0023,2.0023,0,0,1,2-2h6v1A2.0023,2.0023,0,0,0,20,12Zm4-6h4v4H24ZM20,6h2v4H20Zm8,22H4V16H28Z"
  })), children);
});
var RadioPushToTalk32 = /*#__PURE__*/React.forwardRef(function RadioPushToTalk32(_ref100, ref) {
  var children = _ref100.children,
      rest = _objectWithoutProperties(_ref100, _excluded100);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M13 11H19V13H13zM13 15H19V17H13z"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "23",
    r: "2"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M22,7H21V2H19V7H10A2.0023,2.0023,0,0,0,8,9v2H6v2H8v2H6v2H8V28a2.0023,2.0023,0,0,0,2,2H22a2.0023,2.0023,0,0,0,2-2V9A2.0023,2.0023,0,0,0,22,7ZM10,28V9H22V28Z"
  })), children);
});
var RadioPushToTalk24 = /*#__PURE__*/React.forwardRef(function RadioPushToTalk24(_ref101, ref) {
  var children = _ref101.children,
      rest = _objectWithoutProperties(_ref101, _excluded101);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M13 11H19V13H13zM13 15H19V17H13z"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "23",
    r: "2"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M22,7H21V2H19V7H10A2.0023,2.0023,0,0,0,8,9v2H6v2H8v2H6v2H8V28a2.0023,2.0023,0,0,0,2,2H22a2.0023,2.0023,0,0,0,2-2V9A2.0023,2.0023,0,0,0,22,7ZM10,28V9H22V28Z"
  })), children);
});
var RadioPushToTalk20 = /*#__PURE__*/React.forwardRef(function RadioPushToTalk20(_ref102, ref) {
  var children = _ref102.children,
      rest = _objectWithoutProperties(_ref102, _excluded102);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M13 11H19V13H13zM13 15H19V17H13z"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "23",
    r: "2"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M22,7H21V2H19V7H10A2.0023,2.0023,0,0,0,8,9v2H6v2H8v2H6v2H8V28a2.0023,2.0023,0,0,0,2,2H22a2.0023,2.0023,0,0,0,2-2V9A2.0023,2.0023,0,0,0,22,7ZM10,28V9H22V28Z"
  })), children);
});
var RadioPushToTalk16 = /*#__PURE__*/React.forwardRef(function RadioPushToTalk16(_ref103, ref) {
  var children = _ref103.children,
      rest = _objectWithoutProperties(_ref103, _excluded103);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M13 11H19V13H13zM13 15H19V17H13z"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "23",
    r: "2"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M22,7H21V2H19V7H10A2.0023,2.0023,0,0,0,8,9v2H6v2H8v2H6v2H8V28a2.0023,2.0023,0,0,0,2,2H22a2.0023,2.0023,0,0,0,2-2V9A2.0023,2.0023,0,0,0,22,7ZM10,28V9H22V28Z"
  })), children);
});
var RadioButton32 = /*#__PURE__*/React.forwardRef(function RadioButton32(_ref104, ref) {
  var children = _ref104.children,
      rest = _objectWithoutProperties(_ref104, _excluded104);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
  })), children);
});
var RadioButton24 = /*#__PURE__*/React.forwardRef(function RadioButton24(_ref105, ref) {
  var children = _ref105.children,
      rest = _objectWithoutProperties(_ref105, _excluded105);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
  })), children);
});
var RadioButton20 = /*#__PURE__*/React.forwardRef(function RadioButton20(_ref106, ref) {
  var children = _ref106.children,
      rest = _objectWithoutProperties(_ref106, _excluded106);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
  })), children);
});
var RadioButton16 = /*#__PURE__*/React.forwardRef(function RadioButton16(_ref107, ref) {
  var children = _ref107.children,
      rest = _objectWithoutProperties(_ref107, _excluded107);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
  })), children);
});
var RadioButtonChecked32 = /*#__PURE__*/React.forwardRef(function RadioButtonChecked32(_ref108, ref) {
  var children = _ref108.children,
      rest = _objectWithoutProperties(_ref108, _excluded108);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M16,10a6,6,0,1,0,6,6A6,6,0,0,0,16,10Z"
  })), children);
});
var RadioButtonChecked24 = /*#__PURE__*/React.forwardRef(function RadioButtonChecked24(_ref109, ref) {
  var children = _ref109.children,
      rest = _objectWithoutProperties(_ref109, _excluded109);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M16,10a6,6,0,1,0,6,6A6,6,0,0,0,16,10Z"
  })), children);
});
var RadioButtonChecked20 = /*#__PURE__*/React.forwardRef(function RadioButtonChecked20(_ref110, ref) {
  var children = _ref110.children,
      rest = _objectWithoutProperties(_ref110, _excluded110);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M16,10a6,6,0,1,0,6,6A6,6,0,0,0,16,10Z"
  })), children);
});
var RadioButtonChecked16 = /*#__PURE__*/React.forwardRef(function RadioButtonChecked16(_ref111, ref) {
  var children = _ref111.children,
      rest = _objectWithoutProperties(_ref111, _excluded111);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M16,10a6,6,0,1,0,6,6A6,6,0,0,0,16,10Z"
  })), children);
});
var Rain32 = /*#__PURE__*/React.forwardRef(function Rain32(_ref112, ref) {
  var children = _ref112.children,
      rest = _objectWithoutProperties(_ref112, _excluded112);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 22H8.5A6.5 6.5 0 017.2 9.14a9 9 0 0117.6 0A6.5 6.5 0 0123.5 22zM16 4a7 7 0 00-6.94 6.14L9 11 8.14 11a4.5 4.5 0 00.36 9h15a4.5 4.5 0 00.36-9L23 11l-.1-.82A7 7 0 0016 4zM14 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 0114 30zM20 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 0120 30zM8 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 018 30z"
  })), children);
});
var Rain24 = /*#__PURE__*/React.forwardRef(function Rain24(_ref113, ref) {
  var children = _ref113.children,
      rest = _objectWithoutProperties(_ref113, _excluded113);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 22H8.5A6.5 6.5 0 017.2 9.14a9 9 0 0117.6 0A6.5 6.5 0 0123.5 22zM16 4a7 7 0 00-6.94 6.14L9 11 8.14 11a4.5 4.5 0 00.36 9h15a4.5 4.5 0 00.36-9L23 11l-.1-.82A7 7 0 0016 4zM14 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 0114 30zM20 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 0120 30zM8 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 018 30z"
  })), children);
});
var Rain20 = /*#__PURE__*/React.forwardRef(function Rain20(_ref114, ref) {
  var children = _ref114.children,
      rest = _objectWithoutProperties(_ref114, _excluded114);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 22H8.5A6.5 6.5 0 017.2 9.14a9 9 0 0117.6 0A6.5 6.5 0 0123.5 22zM16 4a7 7 0 00-6.94 6.14L9 11 8.14 11a4.5 4.5 0 00.36 9h15a4.5 4.5 0 00.36-9L23 11l-.1-.82A7 7 0 0016 4zM14 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 0114 30zM20 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 0120 30zM8 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 018 30z"
  })), children);
});
var Rain16 = /*#__PURE__*/React.forwardRef(function Rain16(_ref115, ref) {
  var children = _ref115.children,
      rest = _objectWithoutProperties(_ref115, _excluded115);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 22H8.5A6.5 6.5 0 017.2 9.14a9 9 0 0117.6 0A6.5 6.5 0 0123.5 22zM16 4a7 7 0 00-6.94 6.14L9 11 8.14 11a4.5 4.5 0 00.36 9h15a4.5 4.5 0 00.36-9L23 11l-.1-.82A7 7 0 0016 4zM14 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 0114 30zM20 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 0120 30zM8 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 018 30z"
  })), children);
});
var RainDrizzle32 = /*#__PURE__*/React.forwardRef(function RainDrizzle32(_ref116, ref) {
  var children = _ref116.children,
      rest = _objectWithoutProperties(_ref116, _excluded116);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M11,30a1,1,0,0,1-.8944-1.4474l2-4a1,1,0,1,1,1.7887.8946l-2,4A.9979.9979,0,0,1,11,30Z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0A6.4973,6.4973,0,0,0,8.5,22H19.3813L18.105,24.5527a1,1,0,0,0,1.789.8946L21.6177,22H23.5A6.4974,6.4974,0,0,0,24.8008,9.1362ZM23.5,20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20Z"
  })), children);
});
var RainDrizzle24 = /*#__PURE__*/React.forwardRef(function RainDrizzle24(_ref117, ref) {
  var children = _ref117.children,
      rest = _objectWithoutProperties(_ref117, _excluded117);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M11,30a1,1,0,0,1-.8944-1.4474l2-4a1,1,0,1,1,1.7887.8946l-2,4A.9979.9979,0,0,1,11,30Z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0A6.4973,6.4973,0,0,0,8.5,22H19.3813L18.105,24.5527a1,1,0,0,0,1.789.8946L21.6177,22H23.5A6.4974,6.4974,0,0,0,24.8008,9.1362ZM23.5,20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20Z"
  })), children);
});
var RainDrizzle20 = /*#__PURE__*/React.forwardRef(function RainDrizzle20(_ref118, ref) {
  var children = _ref118.children,
      rest = _objectWithoutProperties(_ref118, _excluded118);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M11,30a1,1,0,0,1-.8944-1.4474l2-4a1,1,0,1,1,1.7887.8946l-2,4A.9979.9979,0,0,1,11,30Z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0A6.4973,6.4973,0,0,0,8.5,22H19.3813L18.105,24.5527a1,1,0,0,0,1.789.8946L21.6177,22H23.5A6.4974,6.4974,0,0,0,24.8008,9.1362ZM23.5,20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20Z"
  })), children);
});
var RainDrizzle16 = /*#__PURE__*/React.forwardRef(function RainDrizzle16(_ref119, ref) {
  var children = _ref119.children,
      rest = _objectWithoutProperties(_ref119, _excluded119);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M11,30a1,1,0,0,1-.8944-1.4474l2-4a1,1,0,1,1,1.7887.8946l-2,4A.9979.9979,0,0,1,11,30Z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0A6.4973,6.4973,0,0,0,8.5,22H19.3813L18.105,24.5527a1,1,0,0,0,1.789.8946L21.6177,22H23.5A6.4974,6.4974,0,0,0,24.8008,9.1362ZM23.5,20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20Z"
  })), children);
});
var RainHeavy32 = /*#__PURE__*/React.forwardRef(function RainHeavy32(_ref120, ref) {
  var children = _ref120.children,
      rest = _objectWithoutProperties(_ref120, _excluded120);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M17 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 0117 30zM8 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 018 30z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M30,15.5a6.5323,6.5323,0,0,0-5.1992-6.3638,8.9943,8.9943,0,0,0-17.6006,0A6.4905,6.4905,0,0,0,5.7026,21.3584L4.106,24.5527a1,1,0,1,0,1.7885.8946L7.6174,22l6.7644,0L13.106,24.5527a1,1,0,1,0,1.7885.8946L16.6177,22h6.7641L22.106,24.5527a1,1,0,1,0,1.7885.8946l1.9444-3.89A6.5058,6.5058,0,0,0,30,15.5ZM23.5,20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20Z"
  })), children);
});
var RainHeavy24 = /*#__PURE__*/React.forwardRef(function RainHeavy24(_ref121, ref) {
  var children = _ref121.children,
      rest = _objectWithoutProperties(_ref121, _excluded121);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M17 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 0117 30zM8 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 018 30z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M30,15.5a6.5323,6.5323,0,0,0-5.1992-6.3638,8.9943,8.9943,0,0,0-17.6006,0A6.4905,6.4905,0,0,0,5.7026,21.3584L4.106,24.5527a1,1,0,1,0,1.7885.8946L7.6174,22l6.7644,0L13.106,24.5527a1,1,0,1,0,1.7885.8946L16.6177,22h6.7641L22.106,24.5527a1,1,0,1,0,1.7885.8946l1.9444-3.89A6.5058,6.5058,0,0,0,30,15.5ZM23.5,20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20Z"
  })), children);
});
var RainHeavy20 = /*#__PURE__*/React.forwardRef(function RainHeavy20(_ref122, ref) {
  var children = _ref122.children,
      rest = _objectWithoutProperties(_ref122, _excluded122);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M17 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 0117 30zM8 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 018 30z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M30,15.5a6.5323,6.5323,0,0,0-5.1992-6.3638,8.9943,8.9943,0,0,0-17.6006,0A6.4905,6.4905,0,0,0,5.7026,21.3584L4.106,24.5527a1,1,0,1,0,1.7885.8946L7.6174,22l6.7644,0L13.106,24.5527a1,1,0,1,0,1.7885.8946L16.6177,22h6.7641L22.106,24.5527a1,1,0,1,0,1.7885.8946l1.9444-3.89A6.5058,6.5058,0,0,0,30,15.5ZM23.5,20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20Z"
  })), children);
});
var RainHeavy16 = /*#__PURE__*/React.forwardRef(function RainHeavy16(_ref123, ref) {
  var children = _ref123.children,
      rest = _objectWithoutProperties(_ref123, _excluded123);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M17 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 0117 30zM8 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 018 30z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M30,15.5a6.5323,6.5323,0,0,0-5.1992-6.3638,8.9943,8.9943,0,0,0-17.6006,0A6.4905,6.4905,0,0,0,5.7026,21.3584L4.106,24.5527a1,1,0,1,0,1.7885.8946L7.6174,22l6.7644,0L13.106,24.5527a1,1,0,1,0,1.7885.8946L16.6177,22h6.7641L22.106,24.5527a1,1,0,1,0,1.7885.8946l1.9444-3.89A6.5058,6.5058,0,0,0,30,15.5ZM23.5,20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20Z"
  })), children);
});
var RainScattered32 = /*#__PURE__*/React.forwardRef(function RainScattered32(_ref124, ref) {
  var children = _ref124.children,
      rest = _objectWithoutProperties(_ref124, _excluded124);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5084,32a1.0127,1.0127,0,0,1-.4485-.1054.9986.9986,0,0,1-.4486-1.3418l1.4934-3.0005a1.0025,1.0025,0,0,1,1.7943.8945l-1.4934,3A1.0013,1.0013,0,0,1,8.5084,32Z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M27.232 15.733H29.232V18.733H27.232z",
    transform: "rotate(-45.009 28.232 17.233)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M29 10H32V12H29z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M26.732 3.768H29.732V5.768H26.732z",
    transform: "rotate(-45 28.232 4.768)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H22V3H20z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M12.768 3.268H14.768V6.268H12.768z",
    transform: "rotate(-45 13.768 4.768)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M27,11A5.9955,5.9955,0,0,0,15.6335,8.3311,7.3494,7.3494,0,0,0,13.5,8a7.5509,7.5509,0,0,0-7.1492,5.2441A5.9926,5.9926,0,0,0,8,25h7.3818L14.106,27.5527a1,1,0,1,0,1.7885.8946L17.6177,25H19a5.9853,5.9853,0,0,0,5.2163-8.9463A5.9941,5.9941,0,0,0,27,11ZM19,23H8a3.9925,3.9925,0,0,1-.6731-7.9292L7.99,14.958l.1458-.6562a5.496,5.496,0,0,1,10.7294,0l.1458.6562.6626.1128A3.9925,3.9925,0,0,1,19,23Zm3.9268-8.5107a5.96,5.96,0,0,0-2.2776-1.2452,7.5157,7.5157,0,0,0-3.1853-4.0688,3.9869,3.9869,0,1,1,5.4629,5.314Z"
  })), children);
});
var RainScattered24 = /*#__PURE__*/React.forwardRef(function RainScattered24(_ref125, ref) {
  var children = _ref125.children,
      rest = _objectWithoutProperties(_ref125, _excluded125);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5084,32a1.0127,1.0127,0,0,1-.4485-.1054.9986.9986,0,0,1-.4486-1.3418l1.4934-3.0005a1.0025,1.0025,0,0,1,1.7943.8945l-1.4934,3A1.0013,1.0013,0,0,1,8.5084,32Z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M27.232 15.733H29.232V18.733H27.232z",
    transform: "rotate(-45.009 28.232 17.233)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M29 10H32V12H29z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M26.732 3.768H29.732V5.768H26.732z",
    transform: "rotate(-45 28.232 4.768)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H22V3H20z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M12.768 3.268H14.768V6.268H12.768z",
    transform: "rotate(-45 13.768 4.768)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M27,11A5.9955,5.9955,0,0,0,15.6335,8.3311,7.3494,7.3494,0,0,0,13.5,8a7.5509,7.5509,0,0,0-7.1492,5.2441A5.9926,5.9926,0,0,0,8,25h7.3818L14.106,27.5527a1,1,0,1,0,1.7885.8946L17.6177,25H19a5.9853,5.9853,0,0,0,5.2163-8.9463A5.9941,5.9941,0,0,0,27,11ZM19,23H8a3.9925,3.9925,0,0,1-.6731-7.9292L7.99,14.958l.1458-.6562a5.496,5.496,0,0,1,10.7294,0l.1458.6562.6626.1128A3.9925,3.9925,0,0,1,19,23Zm3.9268-8.5107a5.96,5.96,0,0,0-2.2776-1.2452,7.5157,7.5157,0,0,0-3.1853-4.0688,3.9869,3.9869,0,1,1,5.4629,5.314Z"
  })), children);
});
var RainScattered20 = /*#__PURE__*/React.forwardRef(function RainScattered20(_ref126, ref) {
  var children = _ref126.children,
      rest = _objectWithoutProperties(_ref126, _excluded126);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5084,32a1.0127,1.0127,0,0,1-.4485-.1054.9986.9986,0,0,1-.4486-1.3418l1.4934-3.0005a1.0025,1.0025,0,0,1,1.7943.8945l-1.4934,3A1.0013,1.0013,0,0,1,8.5084,32Z"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M27.232 15.733H29.232V18.733H27.232z",
    transform: "rotate(-45.009 28.232 17.233)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M29 10H32V12H29z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M26.732 3.768H29.732V5.768H26.732z",
    transform: "rotate(-45 28.232 4.768)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H22V3H20z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M12.768 3.268H14.768V6.268H12.768z",
    transform: "rotate(-45 13.768 4.768)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M27,11A5.9955,5.9955,0,0,0,15.6335,8.3311,7.3494,7.3494,0,0,0,13.5,8a7.5509,7.5509,0,0,0-7.1492,5.2441A5.9926,5.9926,0,0,0,8,25h7.3818L14.106,27.5527a1,1,0,1,0,1.7885.8946L17.6177,25H19a5.9853,5.9853,0,0,0,5.2163-8.9463A5.9941,5.9941,0,0,0,27,11ZM19,23H8a3.9925,3.9925,0,0,1-.6731-7.9292L7.99,14.958l.1458-.6562a5.496,5.496,0,0,1,10.7294,0l.1458.6562.6626.1128A3.9925,3.9925,0,0,1,19,23Zm3.9268-8.5107a5.96,5.96,0,0,0-2.2776-1.2452,7.5157,7.5157,0,0,0-3.1853-4.0688,3.9869,3.9869,0,1,1,5.4629,5.314Z"
  })), children);
});
var RainScattered16 = /*#__PURE__*/React.forwardRef(function RainScattered16(_ref127, ref) {
  var children = _ref127.children,
      rest = _objectWithoutProperties(_ref127, _excluded127);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5084,32a1.0127,1.0127,0,0,1-.4485-.1054.9986.9986,0,0,1-.4486-1.3418l1.4934-3.0005a1.0025,1.0025,0,0,1,1.7943.8945l-1.4934,3A1.0013,1.0013,0,0,1,8.5084,32Z"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M27.232 15.733H29.232V18.733H27.232z",
    transform: "rotate(-45.009 28.232 17.233)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M29 10H32V12H29z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M26.732 3.768H29.732V5.768H26.732z",
    transform: "rotate(-45 28.232 4.768)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H22V3H20z"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M12.768 3.268H14.768V6.268H12.768z",
    transform: "rotate(-45 13.768 4.768)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M27,11A5.9955,5.9955,0,0,0,15.6335,8.3311,7.3494,7.3494,0,0,0,13.5,8a7.5509,7.5509,0,0,0-7.1492,5.2441A5.9926,5.9926,0,0,0,8,25h7.3818L14.106,27.5527a1,1,0,1,0,1.7885.8946L17.6177,25H19a5.9853,5.9853,0,0,0,5.2163-8.9463A5.9941,5.9941,0,0,0,27,11ZM19,23H8a3.9925,3.9925,0,0,1-.6731-7.9292L7.99,14.958l.1458-.6562a5.496,5.496,0,0,1,10.7294,0l.1458.6562.6626.1128A3.9925,3.9925,0,0,1,19,23Zm3.9268-8.5107a5.96,5.96,0,0,0-2.2776-1.2452,7.5157,7.5157,0,0,0-3.1853-4.0688,3.9869,3.9869,0,1,1,5.4629,5.314Z"
  })), children);
});
var RainScatteredNight32 = /*#__PURE__*/React.forwardRef(function RainScatteredNight32(_ref128, ref) {
  var children = _ref128.children,
      rest = _objectWithoutProperties(_ref128, _excluded128);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5084 32a1.0115 1.0115 0 01-.4485-.1055.9986.9986 0 01-.4486-1.3418l1.4934-3a1.0025 1.0025 0 011.7943.8945l-1.4934 3A1.0015 1.0015 0 018.5084 32zM29.8442 13.0347a1.5184 1.5184 0 00-1.2309-.8658 5.3587 5.3587 0 01-3.4094-1.7163 6.4648 6.4648 0 01-1.285-6.393 1.6031 1.6031 0 00-.3-1.5459 1.4535 1.4535 0 00-1.3594-.4922l-.0191.0029a7.8549 7.8549 0 00-6.1054 6.48A7.3725 7.3725 0 0013.5 8a7.5511 7.5511 0 00-7.1494 5.2441A5.9926 5.9926 0 008 25h7.3818L14.106 27.5527a1 1 0 101.7885.8946L17.6177 25H19a5.9549 5.9549 0 005.88-7.1455 7.5 7.5 0 004.8672-3.3A1.5381 1.5381 0 0029.8442 13.0347zM19 23H8a3.9926 3.9926 0 01-.6733-7.9292l.663-.1128.1456-.6562a5.496 5.496 0 0110.7294 0l.1456.6562.6626.1128A3.9925 3.9925 0 0119 23zm5.1509-7.0479a5.9639 5.9639 0 00-3.5015-2.708A7.5076 7.5076 0 0018.0286 9.55a6.01 6.01 0 013.77-5.334 8.4581 8.4581 0 001.9395 7.5972A7.4007 7.4007 0 0027.64 14.041 5.4392 5.4392 0 0124.1509 15.9521z"
  })), children);
});
var RainScatteredNight24 = /*#__PURE__*/React.forwardRef(function RainScatteredNight24(_ref129, ref) {
  var children = _ref129.children,
      rest = _objectWithoutProperties(_ref129, _excluded129);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5084 32a1.0115 1.0115 0 01-.4485-.1055.9986.9986 0 01-.4486-1.3418l1.4934-3a1.0025 1.0025 0 011.7943.8945l-1.4934 3A1.0015 1.0015 0 018.5084 32zM29.8442 13.0347a1.5184 1.5184 0 00-1.2309-.8658 5.3587 5.3587 0 01-3.4094-1.7163 6.4648 6.4648 0 01-1.285-6.393 1.6031 1.6031 0 00-.3-1.5459 1.4535 1.4535 0 00-1.3594-.4922l-.0191.0029a7.8549 7.8549 0 00-6.1054 6.48A7.3725 7.3725 0 0013.5 8a7.5511 7.5511 0 00-7.1494 5.2441A5.9926 5.9926 0 008 25h7.3818L14.106 27.5527a1 1 0 101.7885.8946L17.6177 25H19a5.9549 5.9549 0 005.88-7.1455 7.5 7.5 0 004.8672-3.3A1.5381 1.5381 0 0029.8442 13.0347zM19 23H8a3.9926 3.9926 0 01-.6733-7.9292l.663-.1128.1456-.6562a5.496 5.496 0 0110.7294 0l.1456.6562.6626.1128A3.9925 3.9925 0 0119 23zm5.1509-7.0479a5.9639 5.9639 0 00-3.5015-2.708A7.5076 7.5076 0 0018.0286 9.55a6.01 6.01 0 013.77-5.334 8.4581 8.4581 0 001.9395 7.5972A7.4007 7.4007 0 0027.64 14.041 5.4392 5.4392 0 0124.1509 15.9521z"
  })), children);
});
var RainScatteredNight20 = /*#__PURE__*/React.forwardRef(function RainScatteredNight20(_ref130, ref) {
  var children = _ref130.children,
      rest = _objectWithoutProperties(_ref130, _excluded130);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5084 32a1.0115 1.0115 0 01-.4485-.1055.9986.9986 0 01-.4486-1.3418l1.4934-3a1.0025 1.0025 0 011.7943.8945l-1.4934 3A1.0015 1.0015 0 018.5084 32zM29.8442 13.0347a1.5184 1.5184 0 00-1.2309-.8658 5.3587 5.3587 0 01-3.4094-1.7163 6.4648 6.4648 0 01-1.285-6.393 1.6031 1.6031 0 00-.3-1.5459 1.4535 1.4535 0 00-1.3594-.4922l-.0191.0029a7.8549 7.8549 0 00-6.1054 6.48A7.3725 7.3725 0 0013.5 8a7.5511 7.5511 0 00-7.1494 5.2441A5.9926 5.9926 0 008 25h7.3818L14.106 27.5527a1 1 0 101.7885.8946L17.6177 25H19a5.9549 5.9549 0 005.88-7.1455 7.5 7.5 0 004.8672-3.3A1.5381 1.5381 0 0029.8442 13.0347zM19 23H8a3.9926 3.9926 0 01-.6733-7.9292l.663-.1128.1456-.6562a5.496 5.496 0 0110.7294 0l.1456.6562.6626.1128A3.9925 3.9925 0 0119 23zm5.1509-7.0479a5.9639 5.9639 0 00-3.5015-2.708A7.5076 7.5076 0 0018.0286 9.55a6.01 6.01 0 013.77-5.334 8.4581 8.4581 0 001.9395 7.5972A7.4007 7.4007 0 0027.64 14.041 5.4392 5.4392 0 0124.1509 15.9521z"
  })), children);
});
var RainScatteredNight16 = /*#__PURE__*/React.forwardRef(function RainScatteredNight16(_ref131, ref) {
  var children = _ref131.children,
      rest = _objectWithoutProperties(_ref131, _excluded131);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5084 32a1.0115 1.0115 0 01-.4485-.1055.9986.9986 0 01-.4486-1.3418l1.4934-3a1.0025 1.0025 0 011.7943.8945l-1.4934 3A1.0015 1.0015 0 018.5084 32zM29.8442 13.0347a1.5184 1.5184 0 00-1.2309-.8658 5.3587 5.3587 0 01-3.4094-1.7163 6.4648 6.4648 0 01-1.285-6.393 1.6031 1.6031 0 00-.3-1.5459 1.4535 1.4535 0 00-1.3594-.4922l-.0191.0029a7.8549 7.8549 0 00-6.1054 6.48A7.3725 7.3725 0 0013.5 8a7.5511 7.5511 0 00-7.1494 5.2441A5.9926 5.9926 0 008 25h7.3818L14.106 27.5527a1 1 0 101.7885.8946L17.6177 25H19a5.9549 5.9549 0 005.88-7.1455 7.5 7.5 0 004.8672-3.3A1.5381 1.5381 0 0029.8442 13.0347zM19 23H8a3.9926 3.9926 0 01-.6733-7.9292l.663-.1128.1456-.6562a5.496 5.496 0 0110.7294 0l.1456.6562.6626.1128A3.9925 3.9925 0 0119 23zm5.1509-7.0479a5.9639 5.9639 0 00-3.5015-2.708A7.5076 7.5076 0 0018.0286 9.55a6.01 6.01 0 013.77-5.334 8.4581 8.4581 0 001.9395 7.5972A7.4007 7.4007 0 0027.64 14.041 5.4392 5.4392 0 0124.1509 15.9521z"
  })), children);
});
var RainDrop32 = /*#__PURE__*/React.forwardRef(function RainDrop32(_ref132, ref) {
  var children = _ref132.children,
      rest = _objectWithoutProperties(_ref132, _excluded132);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M16,24V22a3.2965,3.2965,0,0,0,3-3h2A5.2668,5.2668,0,0,1,16,24Z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28a9.0114,9.0114,0,0,1-9-9,9.9843,9.9843,0,0,1,1.4941-4.9554L15.1528,3.4367a1.04,1.04,0,0,1,1.6944,0l6.6289,10.5564A10.0633,10.0633,0,0,1,25,19,9.0114,9.0114,0,0,1,16,28ZM16,5.8483l-5.7817,9.2079A7.9771,7.9771,0,0,0,9,19a7,7,0,0,0,14,0,8.0615,8.0615,0,0,0-1.248-3.9953Z"
  })), children);
});
var RainDrop24 = /*#__PURE__*/React.forwardRef(function RainDrop24(_ref133, ref) {
  var children = _ref133.children,
      rest = _objectWithoutProperties(_ref133, _excluded133);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M16,24V22a3.2965,3.2965,0,0,0,3-3h2A5.2668,5.2668,0,0,1,16,24Z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28a9.0114,9.0114,0,0,1-9-9,9.9843,9.9843,0,0,1,1.4941-4.9554L15.1528,3.4367a1.04,1.04,0,0,1,1.6944,0l6.6289,10.5564A10.0633,10.0633,0,0,1,25,19,9.0114,9.0114,0,0,1,16,28ZM16,5.8483l-5.7817,9.2079A7.9771,7.9771,0,0,0,9,19a7,7,0,0,0,14,0,8.0615,8.0615,0,0,0-1.248-3.9953Z"
  })), children);
});
var RainDrop20 = /*#__PURE__*/React.forwardRef(function RainDrop20(_ref134, ref) {
  var children = _ref134.children,
      rest = _objectWithoutProperties(_ref134, _excluded134);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M16,24V22a3.2965,3.2965,0,0,0,3-3h2A5.2668,5.2668,0,0,1,16,24Z"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28a9.0114,9.0114,0,0,1-9-9,9.9843,9.9843,0,0,1,1.4941-4.9554L15.1528,3.4367a1.04,1.04,0,0,1,1.6944,0l6.6289,10.5564A10.0633,10.0633,0,0,1,25,19,9.0114,9.0114,0,0,1,16,28ZM16,5.8483l-5.7817,9.2079A7.9771,7.9771,0,0,0,9,19a7,7,0,0,0,14,0,8.0615,8.0615,0,0,0-1.248-3.9953Z"
  })), children);
});
var RainDrop16 = /*#__PURE__*/React.forwardRef(function RainDrop16(_ref135, ref) {
  var children = _ref135.children,
      rest = _objectWithoutProperties(_ref135, _excluded135);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M16,24V22a3.2965,3.2965,0,0,0,3-3h2A5.2668,5.2668,0,0,1,16,24Z"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28a9.0114,9.0114,0,0,1-9-9,9.9843,9.9843,0,0,1,1.4941-4.9554L15.1528,3.4367a1.04,1.04,0,0,1,1.6944,0l6.6289,10.5564A10.0633,10.0633,0,0,1,25,19,9.0114,9.0114,0,0,1,16,28ZM16,5.8483l-5.7817,9.2079A7.9771,7.9771,0,0,0,9,19a7,7,0,0,0,14,0,8.0615,8.0615,0,0,0-1.248-3.9953Z"
  })), children);
});
var Raw32 = /*#__PURE__*/React.forwardRef(function Raw32(_ref136, ref) {
  var children = _ref136.children,
      rest = _objectWithoutProperties(_ref136, _excluded136);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2 9L28.86 17 28.6 21.54 28.19 18 27.51 12.54 25.49 12.54 24.81 18 24.4 21.54 24.14 17 23.8 9 22 9 23 23 25.27 23 26.03 18.07 26.49 14 26.5 13.97 26.51 14 26.97 18.07 27.73 23 30 23 31 9 29.2 9zM18 9H14a2 2 0 00-2 2V23h2V18h4v5h2V11A2 2 0 0018 9zm-4 7V11h4v5zM10 15V11A2 2 0 008 9H2V23H4V17H5.48l2.34 6H10L7.63 17H8A2 2 0 0010 15zM4 11H8v4H4z"
  })), children);
});
var Raw24 = /*#__PURE__*/React.forwardRef(function Raw24(_ref137, ref) {
  var children = _ref137.children,
      rest = _objectWithoutProperties(_ref137, _excluded137);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2 9L28.86 17 28.6 21.54 28.19 18 27.51 12.54 25.49 12.54 24.81 18 24.4 21.54 24.14 17 23.8 9 22 9 23 23 25.27 23 26.03 18.07 26.49 14 26.5 13.97 26.51 14 26.97 18.07 27.73 23 30 23 31 9 29.2 9zM18 9H14a2 2 0 00-2 2V23h2V18h4v5h2V11A2 2 0 0018 9zm-4 7V11h4v5zM10 15V11A2 2 0 008 9H2V23H4V17H5.48l2.34 6H10L7.63 17H8A2 2 0 0010 15zM4 11H8v4H4z"
  })), children);
});
var Raw20 = /*#__PURE__*/React.forwardRef(function Raw20(_ref138, ref) {
  var children = _ref138.children,
      rest = _objectWithoutProperties(_ref138, _excluded138);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2 9L28.86 17 28.6 21.54 28.19 18 27.51 12.54 25.49 12.54 24.81 18 24.4 21.54 24.14 17 23.8 9 22 9 23 23 25.27 23 26.03 18.07 26.49 14 26.5 13.97 26.51 14 26.97 18.07 27.73 23 30 23 31 9 29.2 9zM18 9H14a2 2 0 00-2 2V23h2V18h4v5h2V11A2 2 0 0018 9zm-4 7V11h4v5zM10 15V11A2 2 0 008 9H2V23H4V17H5.48l2.34 6H10L7.63 17H8A2 2 0 0010 15zM4 11H8v4H4z"
  })), children);
});
var Raw16 = /*#__PURE__*/React.forwardRef(function Raw16(_ref139, ref) {
  var children = _ref139.children,
      rest = _objectWithoutProperties(_ref139, _excluded139);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2 9L28.86 17 28.6 21.54 28.19 18 27.51 12.54 25.49 12.54 24.81 18 24.4 21.54 24.14 17 23.8 9 22 9 23 23 25.27 23 26.03 18.07 26.49 14 26.5 13.97 26.51 14 26.97 18.07 27.73 23 30 23 31 9 29.2 9zM18 9H14a2 2 0 00-2 2V23h2V18h4v5h2V11A2 2 0 0018 9zm-4 7V11h4v5zM10 15V11A2 2 0 008 9H2V23H4V17H5.48l2.34 6H10L7.63 17H8A2 2 0 0010 15zM4 11H8v4H4z"
  })), children);
});
var Receipt32 = /*#__PURE__*/React.forwardRef(function Receipt32(_ref140, ref) {
  var children = _ref140.children,
      rest = _objectWithoutProperties(_ref140, _excluded140);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M21 16H23V18H21zM9 16H17V18H9zM21 12H23V14H21zM9 12H17V14H9zM9 8H23V10H9z"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M25,2H7A2.002,2.002,0,0,0,5,4V29a1,1,0,0,0,1,1H7a.9987.9987,0,0,0,.8-.4L10,26.667,12.2,29.6a1.0353,1.0353,0,0,0,1.6,0L16,26.667,18.2,29.6a1.0353,1.0353,0,0,0,1.6,0L22,26.667,24.2,29.6a.9993.9993,0,0,0,.8.4h1a1,1,0,0,0,1-1V4A2.0023,2.0023,0,0,0,25,2Zm0,25.333L22.8,24.4a1.0353,1.0353,0,0,0-1.6,0L19,27.333,16.8,24.4a1.0353,1.0353,0,0,0-1.6,0L13,27.333,10.8,24.4a1.0353,1.0353,0,0,0-1.6,0L7,27.333V4H25Z"
  })), children);
});
var Receipt24 = /*#__PURE__*/React.forwardRef(function Receipt24(_ref141, ref) {
  var children = _ref141.children,
      rest = _objectWithoutProperties(_ref141, _excluded141);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M21 16H23V18H21zM9 16H17V18H9zM21 12H23V14H21zM9 12H17V14H9zM9 8H23V10H9z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M25,2H7A2.002,2.002,0,0,0,5,4V29a1,1,0,0,0,1,1H7a.9987.9987,0,0,0,.8-.4L10,26.667,12.2,29.6a1.0353,1.0353,0,0,0,1.6,0L16,26.667,18.2,29.6a1.0353,1.0353,0,0,0,1.6,0L22,26.667,24.2,29.6a.9993.9993,0,0,0,.8.4h1a1,1,0,0,0,1-1V4A2.0023,2.0023,0,0,0,25,2Zm0,25.333L22.8,24.4a1.0353,1.0353,0,0,0-1.6,0L19,27.333,16.8,24.4a1.0353,1.0353,0,0,0-1.6,0L13,27.333,10.8,24.4a1.0353,1.0353,0,0,0-1.6,0L7,27.333V4H25Z"
  })), children);
});
var Receipt20 = /*#__PURE__*/React.forwardRef(function Receipt20(_ref142, ref) {
  var children = _ref142.children,
      rest = _objectWithoutProperties(_ref142, _excluded142);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M21 16H23V18H21zM9 16H17V18H9zM21 12H23V14H21zM9 12H17V14H9zM9 8H23V10H9z"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M25,2H7A2.002,2.002,0,0,0,5,4V29a1,1,0,0,0,1,1H7a.9987.9987,0,0,0,.8-.4L10,26.667,12.2,29.6a1.0353,1.0353,0,0,0,1.6,0L16,26.667,18.2,29.6a1.0353,1.0353,0,0,0,1.6,0L22,26.667,24.2,29.6a.9993.9993,0,0,0,.8.4h1a1,1,0,0,0,1-1V4A2.0023,2.0023,0,0,0,25,2Zm0,25.333L22.8,24.4a1.0353,1.0353,0,0,0-1.6,0L19,27.333,16.8,24.4a1.0353,1.0353,0,0,0-1.6,0L13,27.333,10.8,24.4a1.0353,1.0353,0,0,0-1.6,0L7,27.333V4H25Z"
  })), children);
});
var Receipt16 = /*#__PURE__*/React.forwardRef(function Receipt16(_ref143, ref) {
  var children = _ref143.children,
      rest = _objectWithoutProperties(_ref143, _excluded143);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M21 16H23V18H21zM9 16H17V18H9zM21 12H23V14H21zM9 12H17V14H9zM9 8H23V10H9z"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M25,2H7A2.002,2.002,0,0,0,5,4V29a1,1,0,0,0,1,1H7a.9987.9987,0,0,0,.8-.4L10,26.667,12.2,29.6a1.0353,1.0353,0,0,0,1.6,0L16,26.667,18.2,29.6a1.0353,1.0353,0,0,0,1.6,0L22,26.667,24.2,29.6a.9993.9993,0,0,0,.8.4h1a1,1,0,0,0,1-1V4A2.0023,2.0023,0,0,0,25,2Zm0,25.333L22.8,24.4a1.0353,1.0353,0,0,0-1.6,0L19,27.333,16.8,24.4a1.0353,1.0353,0,0,0-1.6,0L13,27.333,10.8,24.4a1.0353,1.0353,0,0,0-1.6,0L7,27.333V4H25Z"
  })), children);
});
var RecentlyViewed32 = /*#__PURE__*/React.forwardRef(function RecentlyViewed32(_ref144, ref) {
  var children = _ref144.children,
      rest = _objectWithoutProperties(_ref144, _excluded144);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M20.59 22L15 16.41 15 7 17 7 17 15.58 22 20.59 20.59 22z"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A13.94,13.94,0,0,0,6,6.23V2H4v8h8V8H7.08A12,12,0,1,1,4,16H2A14,14,0,1,0,16,2Z"
  })), children);
});
var RecentlyViewed24 = /*#__PURE__*/React.forwardRef(function RecentlyViewed24(_ref145, ref) {
  var children = _ref145.children,
      rest = _objectWithoutProperties(_ref145, _excluded145);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M20.59 22L15 16.41 15 7 17 7 17 15.58 22 20.59 20.59 22z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A13.94,13.94,0,0,0,6,6.23V2H4v8h8V8H7.08A12,12,0,1,1,4,16H2A14,14,0,1,0,16,2Z"
  })), children);
});
var RecentlyViewed20 = /*#__PURE__*/React.forwardRef(function RecentlyViewed20(_ref146, ref) {
  var children = _ref146.children,
      rest = _objectWithoutProperties(_ref146, _excluded146);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M20.59 22L15 16.41 15 7 17 7 17 15.58 22 20.59 20.59 22z"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A13.94,13.94,0,0,0,6,6.23V2H4v8h8V8H7.08A12,12,0,1,1,4,16H2A14,14,0,1,0,16,2Z"
  })), children);
});
var RecentlyViewed16 = /*#__PURE__*/React.forwardRef(function RecentlyViewed16(_ref147, ref) {
  var children = _ref147.children,
      rest = _objectWithoutProperties(_ref147, _excluded147);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M20.59 22L15 16.41 15 7 17 7 17 15.58 22 20.59 20.59 22z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A13.94,13.94,0,0,0,6,6.23V2H4v8h8V8H7.08A12,12,0,1,1,4,16H2A14,14,0,1,0,16,2Z"
  })), children);
});
var Recommend32 = /*#__PURE__*/React.forwardRef(function Recommend32(_ref148, ref) {
  var children = _ref148.children,
      rest = _objectWithoutProperties(_ref148, _excluded148);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2a9,9,0,0,0-6,15.69V30l6-4,6,4V17.69A9,9,0,0,0,16,2Zm4,24.26-2.89-1.92L16,23.6l-1.11.74L12,26.26V19.05a8.88,8.88,0,0,0,8,0ZM20.89,16A7,7,0,1,1,23,11,7,7,0,0,1,20.89,16Z"
  })), children);
});
var Recommend24 = /*#__PURE__*/React.forwardRef(function Recommend24(_ref149, ref) {
  var children = _ref149.children,
      rest = _objectWithoutProperties(_ref149, _excluded149);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2a9,9,0,0,0-6,15.69V30l6-4,6,4V17.69A9,9,0,0,0,16,2Zm4,24.26-2.89-1.92L16,23.6l-1.11.74L12,26.26V19.05a8.88,8.88,0,0,0,8,0ZM20.89,16A7,7,0,1,1,23,11,7,7,0,0,1,20.89,16Z"
  })), children);
});
var Recommend20 = /*#__PURE__*/React.forwardRef(function Recommend20(_ref150, ref) {
  var children = _ref150.children,
      rest = _objectWithoutProperties(_ref150, _excluded150);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2a9,9,0,0,0-6,15.69V30l6-4,6,4V17.69A9,9,0,0,0,16,2Zm4,24.26-2.89-1.92L16,23.6l-1.11.74L12,26.26V19.05a8.88,8.88,0,0,0,8,0ZM20.89,16A7,7,0,1,1,23,11,7,7,0,0,1,20.89,16Z"
  })), children);
});
var Recommend16 = /*#__PURE__*/React.forwardRef(function Recommend16(_ref151, ref) {
  var children = _ref151.children,
      rest = _objectWithoutProperties(_ref151, _excluded151);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2a9,9,0,0,0-6,15.69V30l6-4,6,4V17.69A9,9,0,0,0,16,2Zm4,24.26-2.89-1.92L16,23.6l-1.11.74L12,26.26V19.05a8.88,8.88,0,0,0,8,0ZM20.89,16A7,7,0,1,1,23,11,7,7,0,0,1,20.89,16Z"
  })), children);
});
var Recording32 = /*#__PURE__*/React.forwardRef(function Recording32(_ref152, ref) {
  var children = _ref152.children,
      rest = _objectWithoutProperties(_ref152, _excluded152);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M16,12a4,4,0,1,1-4,4,4,4,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z"
  })), children);
});
var Recording24 = /*#__PURE__*/React.forwardRef(function Recording24(_ref153, ref) {
  var children = _ref153.children,
      rest = _objectWithoutProperties(_ref153, _excluded153);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M16,12a4,4,0,1,1-4,4,4,4,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z"
  })), children);
});
var Recording20 = /*#__PURE__*/React.forwardRef(function Recording20(_ref154, ref) {
  var children = _ref154.children,
      rest = _objectWithoutProperties(_ref154, _excluded154);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M16,12a4,4,0,1,1-4,4,4,4,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z"
  })), children);
});
var Recording16 = /*#__PURE__*/React.forwardRef(function Recording16(_ref155, ref) {
  var children = _ref155.children,
      rest = _objectWithoutProperties(_ref155, _excluded155);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M16,12a4,4,0,1,1-4,4,4,4,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z"
  })), children);
});
var RecordingFilled32 = /*#__PURE__*/React.forwardRef(function RecordingFilled32(_ref156, ref) {
  var children = _ref156.children,
      rest = _objectWithoutProperties(_ref156, _excluded156);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "4"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14S23.7,2,16,2z M16,22c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6 S19.3,22,16,22z"
  })), children);
});
var RecordingFilled24 = /*#__PURE__*/React.forwardRef(function RecordingFilled24(_ref157, ref) {
  var children = _ref157.children,
      rest = _objectWithoutProperties(_ref157, _excluded157);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "4"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14S23.7,2,16,2z M16,22c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6 S19.3,22,16,22z"
  })), children);
});
var RecordingFilled20 = /*#__PURE__*/React.forwardRef(function RecordingFilled20(_ref158, ref) {
  var children = _ref158.children,
      rest = _objectWithoutProperties(_ref158, _excluded158);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "4"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14S23.7,2,16,2z M16,22c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6 S19.3,22,16,22z"
  })), children);
});
var RecordingFilled16 = /*#__PURE__*/React.forwardRef(function RecordingFilled16(_ref159, ref) {
  var children = _ref159.children,
      rest = _objectWithoutProperties(_ref159, _excluded159);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "4"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14S23.7,2,16,2z M16,22c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6 S19.3,22,16,22z"
  })), children);
});
var RecordingFilledAlt32 = /*#__PURE__*/React.forwardRef(function RecordingFilledAlt32(_ref160, ref) {
  var children = _ref160.children,
      rest = _objectWithoutProperties(_ref160, _excluded160);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14S23.7,2,16,2z M16,22c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S19.3,22,16,22\tz"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M16,10c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S19.3,10,16,10z",
    "data-icon-path": "inner-path",
    opacity: "0"
  })), children);
});
var RecordingFilledAlt24 = /*#__PURE__*/React.forwardRef(function RecordingFilledAlt24(_ref161, ref) {
  var children = _ref161.children,
      rest = _objectWithoutProperties(_ref161, _excluded161);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14S23.7,2,16,2z M16,22c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S19.3,22,16,22\tz"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M16,10c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S19.3,10,16,10z",
    "data-icon-path": "inner-path",
    opacity: "0"
  })), children);
});
var RecordingFilledAlt20 = /*#__PURE__*/React.forwardRef(function RecordingFilledAlt20(_ref162, ref) {
  var children = _ref162.children,
      rest = _objectWithoutProperties(_ref162, _excluded162);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14S23.7,2,16,2z M16,22c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S19.3,22,16,22\tz"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M16,10c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S19.3,10,16,10z",
    "data-icon-path": "inner-path",
    opacity: "0"
  })), children);
});
var RecordingFilledAlt16 = /*#__PURE__*/React.forwardRef(function RecordingFilledAlt16(_ref163, ref) {
  var children = _ref163.children,
      rest = _objectWithoutProperties(_ref163, _excluded163);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14S23.7,2,16,2z M16,22c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S19.3,22,16,22\tz"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M16,10c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S19.3,10,16,10z",
    "data-icon-path": "inner-path",
    opacity: "0"
  })), children);
});
var Redo32 = /*#__PURE__*/React.forwardRef(function Redo32(_ref164, ref) {
  var children = _ref164.children,
      rest = _objectWithoutProperties(_ref164, _excluded164);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M12,10H24.1851L20.5977,6.4141,22,5,28,11,22,17l-1.4023-1.4146L24.1821,12H12a6,6,0,0,0,0,12h8v2H12a8,8,0,0,1,0-16Z"
  })), children);
});
var Redo24 = /*#__PURE__*/React.forwardRef(function Redo24(_ref165, ref) {
  var children = _ref165.children,
      rest = _objectWithoutProperties(_ref165, _excluded165);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8,11.2c-1.8,0-3.2,1.7-3.2,3.3c0,1.5,1.5,3.2,3.2,3.2H10v1.5H6.8C4.6,19.2,2,17,2,14.5s2-4.8,4.8-4.8\th12.4l-3-3l1.1-1.1l4.8,4.8l-4.8,4.8l-1.1-1.1l3-3H6.8z"
  })), children);
});
var Redo20 = /*#__PURE__*/React.forwardRef(function Redo20(_ref166, ref) {
  var children = _ref166.children,
      rest = _objectWithoutProperties(_ref166, _excluded166);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M5,9.3c-1.5,0-2.8,1.3-2.8,2.7c0,1.5,1.3,2.7,2.8,2.7h4V16H5c-2.3,0-4-1.7-4-4c0-2.2,1.8-4,4-4h11.6\tl-2.5-2.5L15,4.6l4,4l-4,4l-0.9-0.9l2.5-2.5H5z"
  })), children);
});
var Redo16 = /*#__PURE__*/React.forwardRef(function Redo16(_ref167, ref) {
  var children = _ref167.children,
      rest = _objectWithoutProperties(_ref167, _excluded167);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M4,8c-1.2,0-2,0.8-2,2c0,1.2,0.8,2,2,2h3v1H4c-1.7,0-3-1.2-3-3c0-1.7,1.3-3,3-3l9.1,0l-2-2l0.7-0.7\tL15,7.5l-3.2,3.2L11.1,10l2-2L4,8z"
  })), children);
});
var RefEvapotranspiration32 = /*#__PURE__*/React.forwardRef(function RefEvapotranspiration32(_ref168, ref) {
  var children = _ref168.children,
      rest = _objectWithoutProperties(_ref168, _excluded168);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M14 12a3.8978 3.8978 0 01-4-3.777 3.9017 3.9017 0 01.6533-2.0639L13.17 2.4141a1.0381 1.0381 0 011.6592 0L17.3154 6.11A3.9693 3.9693 0 0118 8.223 3.8978 3.8978 0 0114 12zm.0005-7.2368L12.3438 7.2257A1.89 1.89 0 0012 8.223 1.9 1.9 0 0014 10a1.9 1.9 0 002-1.777 1.98 1.98 0 00-.375-1.0466zM7.5 26A5.385 5.385 0 012 20.751 5.3837 5.3837 0 012.874 17.92L6.49 12.5383a1.2168 1.2168 0 012.02-.0006l3.55 5.2777A5.4923 5.4923 0 0113 20.751 5.385 5.385 0 017.5 26zm0-11.38L4.5649 18.9868A3.3586 3.3586 0 004 20.751 3.3855 3.3855 0 007.5 24 3.3855 3.3855 0 0011 20.751a3.4354 3.4354 0 00-.63-1.867zM25 2L20 7l1.4141 1.4141L24 5.8281V16a4.0045 4.0045 0 01-4 4H16v2h4a6.0066 6.0066 0 006-6V5.8281l2.5859 2.586L30 7zM2 28H30V30H2z"
  })), children);
});
var RefEvapotranspiration24 = /*#__PURE__*/React.forwardRef(function RefEvapotranspiration24(_ref169, ref) {
  var children = _ref169.children,
      rest = _objectWithoutProperties(_ref169, _excluded169);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M14 12a3.8978 3.8978 0 01-4-3.777 3.9017 3.9017 0 01.6533-2.0639L13.17 2.4141a1.0381 1.0381 0 011.6592 0L17.3154 6.11A3.9693 3.9693 0 0118 8.223 3.8978 3.8978 0 0114 12zm.0005-7.2368L12.3438 7.2257A1.89 1.89 0 0012 8.223 1.9 1.9 0 0014 10a1.9 1.9 0 002-1.777 1.98 1.98 0 00-.375-1.0466zM7.5 26A5.385 5.385 0 012 20.751 5.3837 5.3837 0 012.874 17.92L6.49 12.5383a1.2168 1.2168 0 012.02-.0006l3.55 5.2777A5.4923 5.4923 0 0113 20.751 5.385 5.385 0 017.5 26zm0-11.38L4.5649 18.9868A3.3586 3.3586 0 004 20.751 3.3855 3.3855 0 007.5 24 3.3855 3.3855 0 0011 20.751a3.4354 3.4354 0 00-.63-1.867zM25 2L20 7l1.4141 1.4141L24 5.8281V16a4.0045 4.0045 0 01-4 4H16v2h4a6.0066 6.0066 0 006-6V5.8281l2.5859 2.586L30 7zM2 28H30V30H2z"
  })), children);
});
var RefEvapotranspiration20 = /*#__PURE__*/React.forwardRef(function RefEvapotranspiration20(_ref170, ref) {
  var children = _ref170.children,
      rest = _objectWithoutProperties(_ref170, _excluded170);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M14 12a3.8978 3.8978 0 01-4-3.777 3.9017 3.9017 0 01.6533-2.0639L13.17 2.4141a1.0381 1.0381 0 011.6592 0L17.3154 6.11A3.9693 3.9693 0 0118 8.223 3.8978 3.8978 0 0114 12zm.0005-7.2368L12.3438 7.2257A1.89 1.89 0 0012 8.223 1.9 1.9 0 0014 10a1.9 1.9 0 002-1.777 1.98 1.98 0 00-.375-1.0466zM7.5 26A5.385 5.385 0 012 20.751 5.3837 5.3837 0 012.874 17.92L6.49 12.5383a1.2168 1.2168 0 012.02-.0006l3.55 5.2777A5.4923 5.4923 0 0113 20.751 5.385 5.385 0 017.5 26zm0-11.38L4.5649 18.9868A3.3586 3.3586 0 004 20.751 3.3855 3.3855 0 007.5 24 3.3855 3.3855 0 0011 20.751a3.4354 3.4354 0 00-.63-1.867zM25 2L20 7l1.4141 1.4141L24 5.8281V16a4.0045 4.0045 0 01-4 4H16v2h4a6.0066 6.0066 0 006-6V5.8281l2.5859 2.586L30 7zM2 28H30V30H2z"
  })), children);
});
var RefEvapotranspiration16 = /*#__PURE__*/React.forwardRef(function RefEvapotranspiration16(_ref171, ref) {
  var children = _ref171.children,
      rest = _objectWithoutProperties(_ref171, _excluded171);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M14 12a3.8978 3.8978 0 01-4-3.777 3.9017 3.9017 0 01.6533-2.0639L13.17 2.4141a1.0381 1.0381 0 011.6592 0L17.3154 6.11A3.9693 3.9693 0 0118 8.223 3.8978 3.8978 0 0114 12zm.0005-7.2368L12.3438 7.2257A1.89 1.89 0 0012 8.223 1.9 1.9 0 0014 10a1.9 1.9 0 002-1.777 1.98 1.98 0 00-.375-1.0466zM7.5 26A5.385 5.385 0 012 20.751 5.3837 5.3837 0 012.874 17.92L6.49 12.5383a1.2168 1.2168 0 012.02-.0006l3.55 5.2777A5.4923 5.4923 0 0113 20.751 5.385 5.385 0 017.5 26zm0-11.38L4.5649 18.9868A3.3586 3.3586 0 004 20.751 3.3855 3.3855 0 007.5 24 3.3855 3.3855 0 0011 20.751a3.4354 3.4354 0 00-.63-1.867zM25 2L20 7l1.4141 1.4141L24 5.8281V16a4.0045 4.0045 0 01-4 4H16v2h4a6.0066 6.0066 0 006-6V5.8281l2.5859 2.586L30 7zM2 28H30V30H2z"
  })), children);
});
var ReflectHorizontal32 = /*#__PURE__*/React.forwardRef(function ReflectHorizontal32(_ref172, ref) {
  var children = _ref172.children,
      rest = _objectWithoutProperties(_ref172, _excluded172);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M19.386,15.2105l9-7A1,1,0,0,1,30,9V23a1,1,0,0,1-1.614.79l-9-7a1,1,0,0,1,0-1.5791Z"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2H17V30H15z",
    transform: "rotate(-180 16 16)"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M13,16a1.001,1.001,0,0,1-.386.79l-9,7A1,1,0,0,1,2,23V9a1,1,0,0,1,1.614-.79l9,7A1.001,1.001,0,0,1,13,16ZM4,20.9556,10.3711,16,4,11.0444Z"
  })), children);
});
var ReflectHorizontal24 = /*#__PURE__*/React.forwardRef(function ReflectHorizontal24(_ref173, ref) {
  var children = _ref173.children,
      rest = _objectWithoutProperties(_ref173, _excluded173);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M19.386,15.2105l9-7A1,1,0,0,1,30,9V23a1,1,0,0,1-1.614.79l-9-7a1,1,0,0,1,0-1.5791Z"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2H17V30H15z",
    transform: "rotate(-180 16 16)"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M13,16a1.001,1.001,0,0,1-.386.79l-9,7A1,1,0,0,1,2,23V9a1,1,0,0,1,1.614-.79l9,7A1.001,1.001,0,0,1,13,16ZM4,20.9556,10.3711,16,4,11.0444Z"
  })), children);
});
var ReflectHorizontal20 = /*#__PURE__*/React.forwardRef(function ReflectHorizontal20(_ref174, ref) {
  var children = _ref174.children,
      rest = _objectWithoutProperties(_ref174, _excluded174);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M19.386,15.2105l9-7A1,1,0,0,1,30,9V23a1,1,0,0,1-1.614.79l-9-7a1,1,0,0,1,0-1.5791Z"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2H17V30H15z",
    transform: "rotate(-180 16 16)"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M13,16a1.001,1.001,0,0,1-.386.79l-9,7A1,1,0,0,1,2,23V9a1,1,0,0,1,1.614-.79l9,7A1.001,1.001,0,0,1,13,16ZM4,20.9556,10.3711,16,4,11.0444Z"
  })), children);
});
var ReflectHorizontal16 = /*#__PURE__*/React.forwardRef(function ReflectHorizontal16(_ref175, ref) {
  var children = _ref175.children,
      rest = _objectWithoutProperties(_ref175, _excluded175);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M19.386,15.2105l9-7A1,1,0,0,1,30,9V23a1,1,0,0,1-1.614.79l-9-7a1,1,0,0,1,0-1.5791Z"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2H17V30H15z",
    transform: "rotate(-180 16 16)"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M13,16a1.001,1.001,0,0,1-.386.79l-9,7A1,1,0,0,1,2,23V9a1,1,0,0,1,1.614-.79l9,7A1.001,1.001,0,0,1,13,16ZM4,20.9556,10.3711,16,4,11.0444Z"
  })), children);
});
var ReflectVertical32 = /*#__PURE__*/React.forwardRef(function ReflectVertical32(_ref176, ref) {
  var children = _ref176.children,
      rest = _objectWithoutProperties(_ref176, _excluded176);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M16.79,19.386l7,9A1,1,0,0,1,23,30H9a1,1,0,0,1-.79-1.614l7-9a1,1,0,0,1,1.5791,0Z"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2H17V30H15z",
    transform: "rotate(-90 16 16)"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M16,13a1.001,1.001,0,0,1-.79-.386l-7-9A1,1,0,0,1,9,2H23a1,1,0,0,1,.79,1.614l-7,9A1.001,1.001,0,0,1,16,13ZM11.0444,4,16,10.3711,20.9556,4Z"
  })), children);
});
var ReflectVertical24 = /*#__PURE__*/React.forwardRef(function ReflectVertical24(_ref177, ref) {
  var children = _ref177.children,
      rest = _objectWithoutProperties(_ref177, _excluded177);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M16.79,19.386l7,9A1,1,0,0,1,23,30H9a1,1,0,0,1-.79-1.614l7-9a1,1,0,0,1,1.5791,0Z"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2H17V30H15z",
    transform: "rotate(-90 16 16)"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M16,13a1.001,1.001,0,0,1-.79-.386l-7-9A1,1,0,0,1,9,2H23a1,1,0,0,1,.79,1.614l-7,9A1.001,1.001,0,0,1,16,13ZM11.0444,4,16,10.3711,20.9556,4Z"
  })), children);
});
var ReflectVertical20 = /*#__PURE__*/React.forwardRef(function ReflectVertical20(_ref178, ref) {
  var children = _ref178.children,
      rest = _objectWithoutProperties(_ref178, _excluded178);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M16.79,19.386l7,9A1,1,0,0,1,23,30H9a1,1,0,0,1-.79-1.614l7-9a1,1,0,0,1,1.5791,0Z"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2H17V30H15z",
    transform: "rotate(-90 16 16)"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M16,13a1.001,1.001,0,0,1-.79-.386l-7-9A1,1,0,0,1,9,2H23a1,1,0,0,1,.79,1.614l-7,9A1.001,1.001,0,0,1,16,13ZM11.0444,4,16,10.3711,20.9556,4Z"
  })), children);
});
var ReflectVertical16 = /*#__PURE__*/React.forwardRef(function ReflectVertical16(_ref179, ref) {
  var children = _ref179.children,
      rest = _objectWithoutProperties(_ref179, _excluded179);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M16.79,19.386l7,9A1,1,0,0,1,23,30H9a1,1,0,0,1-.79-1.614l7-9a1,1,0,0,1,1.5791,0Z"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2H17V30H15z",
    transform: "rotate(-90 16 16)"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M16,13a1.001,1.001,0,0,1-.79-.386l-7-9A1,1,0,0,1,9,2H23a1,1,0,0,1,.79,1.614l-7,9A1.001,1.001,0,0,1,16,13ZM11.0444,4,16,10.3711,20.9556,4Z"
  })), children);
});
var WatsonHealthRegionAnalysisArea32 = /*#__PURE__*/React.forwardRef(function WatsonHealthRegionAnalysisArea32(_ref180, ref) {
  var children = _ref180.children,
      rest = _objectWithoutProperties(_ref180, _excluded180);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M30,23V21H28V19H26v2H23V19H21v2H19v2h2v3H19v2h2v2h2V28h3v2h2V28h2V26H28V23Zm-4,3H23V23h3Z"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16H28A12,12,0,1,0,16,28Z"
  })), children);
});
var WatsonHealthRegionAnalysisArea24 = /*#__PURE__*/React.forwardRef(function WatsonHealthRegionAnalysisArea24(_ref181, ref) {
  var children = _ref181.children,
      rest = _objectWithoutProperties(_ref181, _excluded181);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M30,23V21H28V19H26v2H23V19H21v2H19v2h2v3H19v2h2v2h2V28h3v2h2V28h2V26H28V23Zm-4,3H23V23h3Z"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16H28A12,12,0,1,0,16,28Z"
  })), children);
});
var WatsonHealthRegionAnalysisArea20 = /*#__PURE__*/React.forwardRef(function WatsonHealthRegionAnalysisArea20(_ref182, ref) {
  var children = _ref182.children,
      rest = _objectWithoutProperties(_ref182, _excluded182);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M30,23V21H28V19H26v2H23V19H21v2H19v2h2v3H19v2h2v2h2V28h3v2h2V28h2V26H28V23Zm-4,3H23V23h3Z"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16H28A12,12,0,1,0,16,28Z"
  })), children);
});
var WatsonHealthRegionAnalysisArea16 = /*#__PURE__*/React.forwardRef(function WatsonHealthRegionAnalysisArea16(_ref183, ref) {
  var children = _ref183.children,
      rest = _objectWithoutProperties(_ref183, _excluded183);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M30,23V21H28V19H26v2H23V19H21v2H19v2h2v3H19v2h2v2h2V28h3v2h2V28h2V26H28V23Zm-4,3H23V23h3Z"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16H28A12,12,0,1,0,16,28Z"
  })), children);
});
var WatsonHealthRegionAnalysisVolume32 = /*#__PURE__*/React.forwardRef(function WatsonHealthRegionAnalysisVolume32(_ref184, ref) {
  var children = _ref184.children,
      rest = _objectWithoutProperties(_ref184, _excluded184);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M30,23V21H28V19H26v2H23V19H21v2H19v2h2v3H19v2h2v2h2V28h3v2h2V28h2V26H28V23Zm-4,3H23V23h3Z"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8305,20.3555A24.9534,24.9534,0,0,0,15,22.9644v-2A22.9014,22.9014,0,0,1,4.1335,17.6919,11.979,11.979,0,0,1,4,16a11.9847,11.9847,0,0,1,.1332-1.69,22.9282,22.9282,0,0,1,23.7336,0A11.9847,11.9847,0,0,1,28,16h2A14,14,0,1,0,16,30V28A12.01,12.01,0,0,1,4.8305,20.3555ZM16,4a12.01,12.01,0,0,1,11.17,7.6465,24.8982,24.8982,0,0,0-22.3406,0A12.01,12.01,0,0,1,16,4Z"
  })), children);
});
var WatsonHealthRegionAnalysisVolume24 = /*#__PURE__*/React.forwardRef(function WatsonHealthRegionAnalysisVolume24(_ref185, ref) {
  var children = _ref185.children,
      rest = _objectWithoutProperties(_ref185, _excluded185);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M30,23V21H28V19H26v2H23V19H21v2H19v2h2v3H19v2h2v2h2V28h3v2h2V28h2V26H28V23Zm-4,3H23V23h3Z"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8305,20.3555A24.9534,24.9534,0,0,0,15,22.9644v-2A22.9014,22.9014,0,0,1,4.1335,17.6919,11.979,11.979,0,0,1,4,16a11.9847,11.9847,0,0,1,.1332-1.69,22.9282,22.9282,0,0,1,23.7336,0A11.9847,11.9847,0,0,1,28,16h2A14,14,0,1,0,16,30V28A12.01,12.01,0,0,1,4.8305,20.3555ZM16,4a12.01,12.01,0,0,1,11.17,7.6465,24.8982,24.8982,0,0,0-22.3406,0A12.01,12.01,0,0,1,16,4Z"
  })), children);
});
var WatsonHealthRegionAnalysisVolume20 = /*#__PURE__*/React.forwardRef(function WatsonHealthRegionAnalysisVolume20(_ref186, ref) {
  var children = _ref186.children,
      rest = _objectWithoutProperties(_ref186, _excluded186);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M30,23V21H28V19H26v2H23V19H21v2H19v2h2v3H19v2h2v2h2V28h3v2h2V28h2V26H28V23Zm-4,3H23V23h3Z"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8305,20.3555A24.9534,24.9534,0,0,0,15,22.9644v-2A22.9014,22.9014,0,0,1,4.1335,17.6919,11.979,11.979,0,0,1,4,16a11.9847,11.9847,0,0,1,.1332-1.69,22.9282,22.9282,0,0,1,23.7336,0A11.9847,11.9847,0,0,1,28,16h2A14,14,0,1,0,16,30V28A12.01,12.01,0,0,1,4.8305,20.3555ZM16,4a12.01,12.01,0,0,1,11.17,7.6465,24.8982,24.8982,0,0,0-22.3406,0A12.01,12.01,0,0,1,16,4Z"
  })), children);
});
var WatsonHealthRegionAnalysisVolume16 = /*#__PURE__*/React.forwardRef(function WatsonHealthRegionAnalysisVolume16(_ref187, ref) {
  var children = _ref187.children,
      rest = _objectWithoutProperties(_ref187, _excluded187);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M30,23V21H28V19H26v2H23V19H21v2H19v2h2v3H19v2h2v2h2V28h3v2h2V28h2V26H28V23Zm-4,3H23V23h3Z"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8305,20.3555A24.9534,24.9534,0,0,0,15,22.9644v-2A22.9014,22.9014,0,0,1,4.1335,17.6919,11.979,11.979,0,0,1,4,16a11.9847,11.9847,0,0,1,.1332-1.69,22.9282,22.9282,0,0,1,23.7336,0A11.9847,11.9847,0,0,1,28,16h2A14,14,0,1,0,16,30V28A12.01,12.01,0,0,1,4.8305,20.3555ZM16,4a12.01,12.01,0,0,1,11.17,7.6465,24.8982,24.8982,0,0,0-22.3406,0A12.01,12.01,0,0,1,16,4Z"
  })), children);
});
var WatsonHealthRegistration32 = /*#__PURE__*/React.forwardRef(function WatsonHealthRegistration32(_ref188, ref) {
  var children = _ref188.children,
      rest = _objectWithoutProperties(_ref188, _excluded188);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M28 25H20a2.0027 2.0027 0 01-2-2V20h2v3h8V9H20v3H18V9a2.0023 2.0023 0 012-2h8a2.0023 2.0023 0 012 2V23A2.0027 2.0027 0 0128 25zM8 15H12V17H8z"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M20 15H24V17H20zM14 15H18V17H14zM12 25H4a2.0023 2.0023 0 01-2-2V9A2.002 2.002 0 014 7h8a2.002 2.002 0 012 2v3H12V9H4V23h8V20h2v3A2.0023 2.0023 0 0112 25z"
  })), children);
});
var WatsonHealthRegistration24 = /*#__PURE__*/React.forwardRef(function WatsonHealthRegistration24(_ref189, ref) {
  var children = _ref189.children,
      rest = _objectWithoutProperties(_ref189, _excluded189);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M28 25H20a2.0027 2.0027 0 01-2-2V20h2v3h8V9H20v3H18V9a2.0023 2.0023 0 012-2h8a2.0023 2.0023 0 012 2V23A2.0027 2.0027 0 0128 25zM8 15H12V17H8z"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M20 15H24V17H20zM14 15H18V17H14zM12 25H4a2.0023 2.0023 0 01-2-2V9A2.002 2.002 0 014 7h8a2.002 2.002 0 012 2v3H12V9H4V23h8V20h2v3A2.0023 2.0023 0 0112 25z"
  })), children);
});
var WatsonHealthRegistration20 = /*#__PURE__*/React.forwardRef(function WatsonHealthRegistration20(_ref190, ref) {
  var children = _ref190.children,
      rest = _objectWithoutProperties(_ref190, _excluded190);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M28 25H20a2.0027 2.0027 0 01-2-2V20h2v3h8V9H20v3H18V9a2.0023 2.0023 0 012-2h8a2.0023 2.0023 0 012 2V23A2.0027 2.0027 0 0128 25zM8 15H12V17H8z"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M20 15H24V17H20zM14 15H18V17H14zM12 25H4a2.0023 2.0023 0 01-2-2V9A2.002 2.002 0 014 7h8a2.002 2.002 0 012 2v3H12V9H4V23h8V20h2v3A2.0023 2.0023 0 0112 25z"
  })), children);
});
var WatsonHealthRegistration16 = /*#__PURE__*/React.forwardRef(function WatsonHealthRegistration16(_ref191, ref) {
  var children = _ref191.children,
      rest = _objectWithoutProperties(_ref191, _excluded191);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M28 25H20a2.0027 2.0027 0 01-2-2V20h2v3h8V9H20v3H18V9a2.0023 2.0023 0 012-2h8a2.0023 2.0023 0 012 2V23A2.0027 2.0027 0 0128 25zM8 15H12V17H8z"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M20 15H24V17H20zM14 15H18V17H14zM12 25H4a2.0023 2.0023 0 01-2-2V9A2.002 2.002 0 014 7h8a2.002 2.002 0 012 2v3H12V9H4V23h8V20h2v3A2.0023 2.0023 0 0112 25z"
  })), children);
});
var Reminder32 = /*#__PURE__*/React.forwardRef(function Reminder32(_ref192, ref) {
  var children = _ref192.children,
      rest = _objectWithoutProperties(_ref192, _excluded192);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M30,23.3818l-2-1V20a6.0046,6.0046,0,0,0-5-5.91V12H21v2.09A6.0046,6.0046,0,0,0,16,20v2.3818l-2,1V28h6v2h4V28h6ZM28,26H16V24.6182l2-1V20a4,4,0,0,1,8,0v3.6182l2,1Z"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6a2,2,0,0,0-2-2H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V6h4V8h2V6h8V8h2V6h4v6h2Z"
  })), children);
});
var Reminder24 = /*#__PURE__*/React.forwardRef(function Reminder24(_ref193, ref) {
  var children = _ref193.children,
      rest = _objectWithoutProperties(_ref193, _excluded193);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M30,23.3818l-2-1V20a6.0046,6.0046,0,0,0-5-5.91V12H21v2.09A6.0046,6.0046,0,0,0,16,20v2.3818l-2,1V28h6v2h4V28h6ZM28,26H16V24.6182l2-1V20a4,4,0,0,1,8,0v3.6182l2,1Z"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6a2,2,0,0,0-2-2H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V6h4V8h2V6h8V8h2V6h4v6h2Z"
  })), children);
});
var Reminder20 = /*#__PURE__*/React.forwardRef(function Reminder20(_ref194, ref) {
  var children = _ref194.children,
      rest = _objectWithoutProperties(_ref194, _excluded194);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M30,23.3818l-2-1V20a6.0046,6.0046,0,0,0-5-5.91V12H21v2.09A6.0046,6.0046,0,0,0,16,20v2.3818l-2,1V28h6v2h4V28h6ZM28,26H16V24.6182l2-1V20a4,4,0,0,1,8,0v3.6182l2,1Z"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6a2,2,0,0,0-2-2H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V6h4V8h2V6h8V8h2V6h4v6h2Z"
  })), children);
});
var Reminder16 = /*#__PURE__*/React.forwardRef(function Reminder16(_ref195, ref) {
  var children = _ref195.children,
      rest = _objectWithoutProperties(_ref195, _excluded195);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M30,23.3818l-2-1V20a6.0046,6.0046,0,0,0-5-5.91V12H21v2.09A6.0046,6.0046,0,0,0,16,20v2.3818l-2,1V28h6v2h4V28h6ZM28,26H16V24.6182l2-1V20a4,4,0,0,1,8,0v3.6182l2,1Z"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6a2,2,0,0,0-2-2H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V6h4V8h2V6h8V8h2V6h4v6h2Z"
  })), children);
});
var ReminderMedical32 = /*#__PURE__*/React.forwardRef(function ReminderMedical32(_ref196, ref) {
  var children = _ref196.children,
      rest = _objectWithoutProperties(_ref196, _excluded196);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M27,12v2h1v4a3,3,0,0,1-6,0V14h1V12H20v6a5.0083,5.0083,0,0,0,4,4.8989V24a4,4,0,0,1-8,0V21.8157a3,3,0,1,0-2,0V24a6,6,0,0,0,12,0V22.8989A5.0083,5.0083,0,0,0,30,18V12ZM15,18a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,15,18Z"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2l4,0V26L6,26V6h4V8h2V6h8V8h2V6h4v4h2V6A2,2,0,0,0,26,4Z"
  })), children);
});
var ReminderMedical24 = /*#__PURE__*/React.forwardRef(function ReminderMedical24(_ref197, ref) {
  var children = _ref197.children,
      rest = _objectWithoutProperties(_ref197, _excluded197);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M27,12v2h1v4a3,3,0,0,1-6,0V14h1V12H20v6a5.0083,5.0083,0,0,0,4,4.8989V24a4,4,0,0,1-8,0V21.8157a3,3,0,1,0-2,0V24a6,6,0,0,0,12,0V22.8989A5.0083,5.0083,0,0,0,30,18V12ZM15,18a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,15,18Z"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2l4,0V26L6,26V6h4V8h2V6h8V8h2V6h4v4h2V6A2,2,0,0,0,26,4Z"
  })), children);
});
var ReminderMedical20 = /*#__PURE__*/React.forwardRef(function ReminderMedical20(_ref198, ref) {
  var children = _ref198.children,
      rest = _objectWithoutProperties(_ref198, _excluded198);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M27,12v2h1v4a3,3,0,0,1-6,0V14h1V12H20v6a5.0083,5.0083,0,0,0,4,4.8989V24a4,4,0,0,1-8,0V21.8157a3,3,0,1,0-2,0V24a6,6,0,0,0,12,0V22.8989A5.0083,5.0083,0,0,0,30,18V12ZM15,18a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,15,18Z"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2l4,0V26L6,26V6h4V8h2V6h8V8h2V6h4v4h2V6A2,2,0,0,0,26,4Z"
  })), children);
});
var ReminderMedical16 = /*#__PURE__*/React.forwardRef(function ReminderMedical16(_ref199, ref) {
  var children = _ref199.children,
      rest = _objectWithoutProperties(_ref199, _excluded199);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M27,12v2h1v4a3,3,0,0,1-6,0V14h1V12H20v6a5.0083,5.0083,0,0,0,4,4.8989V24a4,4,0,0,1-8,0V21.8157a3,3,0,1,0-2,0V24a6,6,0,0,0,12,0V22.8989A5.0083,5.0083,0,0,0,30,18V12ZM15,18a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,15,18Z"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2l4,0V26L6,26V6h4V8h2V6h8V8h2V6h4v4h2V6A2,2,0,0,0,26,4Z"
  })), children);
});
var Renew32 = /*#__PURE__*/React.forwardRef(function Renew32(_ref200, ref) {
  var children = _ref200.children,
      rest = _objectWithoutProperties(_ref200, _excluded200);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10H6.78A11 11 0 0127 16h2A13 13 0 006 7.68V4H4v8h8zM20 22h5.22A11 11 0 015 16H3a13 13 0 0023 8.32V28h2V20H20z"
  })), children);
});
var Renew24 = /*#__PURE__*/React.forwardRef(function Renew24(_ref201, ref) {
  var children = _ref201.children,
      rest = _objectWithoutProperties(_ref201, _excluded201);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10H6.78A11 11 0 0127 16h2A13 13 0 006 7.68V4H4v8h8zM20 22h5.22A11 11 0 015 16H3a13 13 0 0023 8.32V28h2V20H20z"
  })), children);
});
var Renew20 = /*#__PURE__*/React.forwardRef(function Renew20(_ref202, ref) {
  var children = _ref202.children,
      rest = _objectWithoutProperties(_ref202, _excluded202);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10H6.78A11 11 0 0127 16h2A13 13 0 006 7.68V4H4v8h8zM20 22h5.22A11 11 0 015 16H3a13 13 0 0023 8.32V28h2V20H20z"
  })), children);
});
var Renew16 = /*#__PURE__*/React.forwardRef(function Renew16(_ref203, ref) {
  var children = _ref203.children,
      rest = _objectWithoutProperties(_ref203, _excluded203);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10H6.78A11 11 0 0127 16h2A13 13 0 006 7.68V4H4v8h8zM20 22h5.22A11 11 0 015 16H3a13 13 0 0023 8.32V28h2V20H20z"
  })), children);
});
var Repeat32 = /*#__PURE__*/React.forwardRef(function Repeat32(_ref204, ref) {
  var children = _ref204.children,
      rest = _objectWithoutProperties(_ref204, _excluded204);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H26.1719l-3.586-3.5859L24 1l6 6-6 6-1.4141-1.4141L26.1719 8H6v7H4V8A2.0024 2.0024 0 016 6zM9.4141 20.4141L5.8281 24H26V17h2v7a2.0024 2.0024 0 01-2 2H5.8281L9.414 29.5859 8 31 2 25l6-6z"
  })), children);
});
var Repeat24 = /*#__PURE__*/React.forwardRef(function Repeat24(_ref205, ref) {
  var children = _ref205.children,
      rest = _objectWithoutProperties(_ref205, _excluded205);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H26.1719l-3.586-3.5859L24 1l6 6-6 6-1.4141-1.4141L26.1719 8H6v7H4V8A2.0024 2.0024 0 016 6zM9.4141 20.4141L5.8281 24H26V17h2v7a2.0024 2.0024 0 01-2 2H5.8281L9.414 29.5859 8 31 2 25l6-6z"
  })), children);
});
var Repeat20 = /*#__PURE__*/React.forwardRef(function Repeat20(_ref206, ref) {
  var children = _ref206.children,
      rest = _objectWithoutProperties(_ref206, _excluded206);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H26.1719l-3.586-3.5859L24 1l6 6-6 6-1.4141-1.4141L26.1719 8H6v7H4V8A2.0024 2.0024 0 016 6zM9.4141 20.4141L5.8281 24H26V17h2v7a2.0024 2.0024 0 01-2 2H5.8281L9.414 29.5859 8 31 2 25l6-6z"
  })), children);
});
var Repeat16 = /*#__PURE__*/React.forwardRef(function Repeat16(_ref207, ref) {
  var children = _ref207.children,
      rest = _objectWithoutProperties(_ref207, _excluded207);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H26.1719l-3.586-3.5859L24 1l6 6-6 6-1.4141-1.4141L26.1719 8H6v7H4V8A2.0024 2.0024 0 016 6zM9.4141 20.4141L5.8281 24H26V17h2v7a2.0024 2.0024 0 01-2 2H5.8281L9.414 29.5859 8 31 2 25l6-6z"
  })), children);
});
var RepeatOne32 = /*#__PURE__*/React.forwardRef(function RepeatOne32(_ref208, ref) {
  var children = _ref208.children,
      rest = _objectWithoutProperties(_ref208, _excluded208);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H26.1719l-3.586-3.5859L24 1l6 6-6 6-1.4141-1.4141L26.1719 8H6v7H4V8A2.0024 2.0024 0 016 6zM9.4141 20.4141L5.8281 24H26V17h2v7a2.0024 2.0024 0 01-2 2H5.8281L9.414 29.5859 8 31 2 25l6-6z"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M17 19L17 11 15 11 15 12 13 12 13 14 15 14 15 19 13 19 13 21 19 21 19 19 17 19z"
  })), children);
});
var RepeatOne24 = /*#__PURE__*/React.forwardRef(function RepeatOne24(_ref209, ref) {
  var children = _ref209.children,
      rest = _objectWithoutProperties(_ref209, _excluded209);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H26.1719l-3.586-3.5859L24 1l6 6-6 6-1.4141-1.4141L26.1719 8H6v7H4V8A2.0024 2.0024 0 016 6zM9.4141 20.4141L5.8281 24H26V17h2v7a2.0024 2.0024 0 01-2 2H5.8281L9.414 29.5859 8 31 2 25l6-6z"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M17 19L17 11 15 11 15 12 13 12 13 14 15 14 15 19 13 19 13 21 19 21 19 19 17 19z"
  })), children);
});
var RepeatOne20 = /*#__PURE__*/React.forwardRef(function RepeatOne20(_ref210, ref) {
  var children = _ref210.children,
      rest = _objectWithoutProperties(_ref210, _excluded210);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H26.1719l-3.586-3.5859L24 1l6 6-6 6-1.4141-1.4141L26.1719 8H6v7H4V8A2.0024 2.0024 0 016 6zM9.4141 20.4141L5.8281 24H26V17h2v7a2.0024 2.0024 0 01-2 2H5.8281L9.414 29.5859 8 31 2 25l6-6z"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M17 19L17 11 15 11 15 12 13 12 13 14 15 14 15 19 13 19 13 21 19 21 19 19 17 19z"
  })), children);
});
var RepeatOne16 = /*#__PURE__*/React.forwardRef(function RepeatOne16(_ref211, ref) {
  var children = _ref211.children,
      rest = _objectWithoutProperties(_ref211, _excluded211);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H26.1719l-3.586-3.5859L24 1l6 6-6 6-1.4141-1.4141L26.1719 8H6v7H4V8A2.0024 2.0024 0 016 6zM9.4141 20.4141L5.8281 24H26V17h2v7a2.0024 2.0024 0 01-2 2H5.8281L9.414 29.5859 8 31 2 25l6-6z"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M17 19L17 11 15 11 15 12 13 12 13 14 15 14 15 19 13 19 13 21 19 21 19 19 17 19z"
  })), children);
});
var Replicate32 = /*#__PURE__*/React.forwardRef(function Replicate32(_ref212, ref) {
  var children = _ref212.children,
      rest = _objectWithoutProperties(_ref212, _excluded212);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M28 8h2V4a2.0021 2.0021 0 00-2-2H24V4h4zM17 2H21V4H17zM28 11H30V15H28zM28 18v4H24V10a2.0023 2.0023 0 00-2-2H10V4h4V2H10A2.0023 2.0023 0 008 4V8H4a2.0023 2.0023 0 00-2 2V28a2.0023 2.0023 0 002 2H22a2.0023 2.0023 0 002-2V24h4a2.0023 2.0023 0 002-2V18zM22 28H4V10H22z"
  })), children);
});
var Replicate24 = /*#__PURE__*/React.forwardRef(function Replicate24(_ref213, ref) {
  var children = _ref213.children,
      rest = _objectWithoutProperties(_ref213, _excluded213);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M28 8h2V4a2.0021 2.0021 0 00-2-2H24V4h4zM17 2H21V4H17zM28 11H30V15H28zM28 18v4H24V10a2.0023 2.0023 0 00-2-2H10V4h4V2H10A2.0023 2.0023 0 008 4V8H4a2.0023 2.0023 0 00-2 2V28a2.0023 2.0023 0 002 2H22a2.0023 2.0023 0 002-2V24h4a2.0023 2.0023 0 002-2V18zM22 28H4V10H22z"
  })), children);
});
var Replicate20 = /*#__PURE__*/React.forwardRef(function Replicate20(_ref214, ref) {
  var children = _ref214.children,
      rest = _objectWithoutProperties(_ref214, _excluded214);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M28 8h2V4a2.0021 2.0021 0 00-2-2H24V4h4zM17 2H21V4H17zM28 11H30V15H28zM28 18v4H24V10a2.0023 2.0023 0 00-2-2H10V4h4V2H10A2.0023 2.0023 0 008 4V8H4a2.0023 2.0023 0 00-2 2V28a2.0023 2.0023 0 002 2H22a2.0023 2.0023 0 002-2V24h4a2.0023 2.0023 0 002-2V18zM22 28H4V10H22z"
  })), children);
});
var Replicate16 = /*#__PURE__*/React.forwardRef(function Replicate16(_ref215, ref) {
  var children = _ref215.children,
      rest = _objectWithoutProperties(_ref215, _excluded215);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M28 8h2V4a2.0021 2.0021 0 00-2-2H24V4h4zM17 2H21V4H17zM28 11H30V15H28zM28 18v4H24V10a2.0023 2.0023 0 00-2-2H10V4h4V2H10A2.0023 2.0023 0 008 4V8H4a2.0023 2.0023 0 00-2 2V28a2.0023 2.0023 0 002 2H22a2.0023 2.0023 0 002-2V24h4a2.0023 2.0023 0 002-2V18zM22 28H4V10H22z"
  })), children);
});
var Reply32 = /*#__PURE__*/React.forwardRef(function Reply32(_ref216, ref) {
  var children = _ref216.children,
      rest = _objectWithoutProperties(_ref216, _excluded216);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M28.88,30a1,1,0,0,1-.88-.5A15.19,15.19,0,0,0,15,22v6a1,1,0,0,1-.62.92,1,1,0,0,1-1.09-.21l-12-12a1,1,0,0,1,0-1.42l12-12a1,1,0,0,1,1.09-.21A1,1,0,0,1,15,4v6.11a17.19,17.19,0,0,1,15,17,16.34,16.34,0,0,1-.13,2,1,1,0,0,1-.79.86ZM14.5,20A17.62,17.62,0,0,1,28,26,15.31,15.31,0,0,0,13.91,12,1,1,0,0,1,13,11V6.41L3.41,16,13,25.59V21a1,1,0,0,1,1-1h.54Z"
  })), children);
});
var Reply24 = /*#__PURE__*/React.forwardRef(function Reply24(_ref217, ref) {
  var children = _ref217.children,
      rest = _objectWithoutProperties(_ref217, _excluded217);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M28.88,30a1,1,0,0,1-.88-.5A15.19,15.19,0,0,0,15,22v6a1,1,0,0,1-.62.92,1,1,0,0,1-1.09-.21l-12-12a1,1,0,0,1,0-1.42l12-12a1,1,0,0,1,1.09-.21A1,1,0,0,1,15,4v6.11a17.19,17.19,0,0,1,15,17,16.34,16.34,0,0,1-.13,2,1,1,0,0,1-.79.86ZM14.5,20A17.62,17.62,0,0,1,28,26,15.31,15.31,0,0,0,13.91,12,1,1,0,0,1,13,11V6.41L3.41,16,13,25.59V21a1,1,0,0,1,1-1h.54Z"
  })), children);
});
var Reply20 = /*#__PURE__*/React.forwardRef(function Reply20(_ref218, ref) {
  var children = _ref218.children,
      rest = _objectWithoutProperties(_ref218, _excluded218);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M28.88,30a1,1,0,0,1-.88-.5A15.19,15.19,0,0,0,15,22v6a1,1,0,0,1-.62.92,1,1,0,0,1-1.09-.21l-12-12a1,1,0,0,1,0-1.42l12-12a1,1,0,0,1,1.09-.21A1,1,0,0,1,15,4v6.11a17.19,17.19,0,0,1,15,17,16.34,16.34,0,0,1-.13,2,1,1,0,0,1-.79.86ZM14.5,20A17.62,17.62,0,0,1,28,26,15.31,15.31,0,0,0,13.91,12,1,1,0,0,1,13,11V6.41L3.41,16,13,25.59V21a1,1,0,0,1,1-1h.54Z"
  })), children);
});
var Reply16 = /*#__PURE__*/React.forwardRef(function Reply16(_ref219, ref) {
  var children = _ref219.children,
      rest = _objectWithoutProperties(_ref219, _excluded219);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M28.88,30a1,1,0,0,1-.88-.5A15.19,15.19,0,0,0,15,22v6a1,1,0,0,1-.62.92,1,1,0,0,1-1.09-.21l-12-12a1,1,0,0,1,0-1.42l12-12a1,1,0,0,1,1.09-.21A1,1,0,0,1,15,4v6.11a17.19,17.19,0,0,1,15,17,16.34,16.34,0,0,1-.13,2,1,1,0,0,1-.79.86ZM14.5,20A17.62,17.62,0,0,1,28,26,15.31,15.31,0,0,0,13.91,12,1,1,0,0,1,13,11V6.41L3.41,16,13,25.59V21a1,1,0,0,1,1-1h.54Z"
  })), children);
});
var ReplyAll32 = /*#__PURE__*/React.forwardRef(function ReplyAll32(_ref220, ref) {
  var children = _ref220.children,
      rest = _objectWithoutProperties(_ref220, _excluded220);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M19,29a.9989.9989,0,0,1-.768-.36l-10-12a1,1,0,0,1,0-1.28l10-12A1,1,0,0,1,20,4v7.0325c7.0074.4629,11,5.86,11,14.9677a1,1,0,0,1-1.8.6c-2.8218-3.7623-5.3912-5.3463-9.2-5.5716V28a1,1,0,0,1-1,1ZM10.3016,16,18,25.238V20a1,1,0,0,1,1-1,12.7127,12.7127,0,0,1,9.8414,4.0909C28.0864,16.5553,24.6587,13,19,13a1,1,0,0,1-1-1V6.7618Z"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4639,28.9182,1.2318,16.64a1,1,0,0,1,0-1.28L11.4638,3.0792,13,4.36,3.3016,16,13,27.638Z"
  })), children);
});
var ReplyAll24 = /*#__PURE__*/React.forwardRef(function ReplyAll24(_ref221, ref) {
  var children = _ref221.children,
      rest = _objectWithoutProperties(_ref221, _excluded221);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M19,29a.9989.9989,0,0,1-.768-.36l-10-12a1,1,0,0,1,0-1.28l10-12A1,1,0,0,1,20,4v7.0325c7.0074.4629,11,5.86,11,14.9677a1,1,0,0,1-1.8.6c-2.8218-3.7623-5.3912-5.3463-9.2-5.5716V28a1,1,0,0,1-1,1ZM10.3016,16,18,25.238V20a1,1,0,0,1,1-1,12.7127,12.7127,0,0,1,9.8414,4.0909C28.0864,16.5553,24.6587,13,19,13a1,1,0,0,1-1-1V6.7618Z"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4639,28.9182,1.2318,16.64a1,1,0,0,1,0-1.28L11.4638,3.0792,13,4.36,3.3016,16,13,27.638Z"
  })), children);
});
var ReplyAll20 = /*#__PURE__*/React.forwardRef(function ReplyAll20(_ref222, ref) {
  var children = _ref222.children,
      rest = _objectWithoutProperties(_ref222, _excluded222);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M19,29a.9989.9989,0,0,1-.768-.36l-10-12a1,1,0,0,1,0-1.28l10-12A1,1,0,0,1,20,4v7.0325c7.0074.4629,11,5.86,11,14.9677a1,1,0,0,1-1.8.6c-2.8218-3.7623-5.3912-5.3463-9.2-5.5716V28a1,1,0,0,1-1,1ZM10.3016,16,18,25.238V20a1,1,0,0,1,1-1,12.7127,12.7127,0,0,1,9.8414,4.0909C28.0864,16.5553,24.6587,13,19,13a1,1,0,0,1-1-1V6.7618Z"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4639,28.9182,1.2318,16.64a1,1,0,0,1,0-1.28L11.4638,3.0792,13,4.36,3.3016,16,13,27.638Z"
  })), children);
});
var ReplyAll16 = /*#__PURE__*/React.forwardRef(function ReplyAll16(_ref223, ref) {
  var children = _ref223.children,
      rest = _objectWithoutProperties(_ref223, _excluded223);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M19,29a.9989.9989,0,0,1-.768-.36l-10-12a1,1,0,0,1,0-1.28l10-12A1,1,0,0,1,20,4v7.0325c7.0074.4629,11,5.86,11,14.9677a1,1,0,0,1-1.8.6c-2.8218-3.7623-5.3912-5.3463-9.2-5.5716V28a1,1,0,0,1-1,1ZM10.3016,16,18,25.238V20a1,1,0,0,1,1-1,12.7127,12.7127,0,0,1,9.8414,4.0909C28.0864,16.5553,24.6587,13,19,13a1,1,0,0,1-1-1V6.7618Z"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4639,28.9182,1.2318,16.64a1,1,0,0,1,0-1.28L11.4638,3.0792,13,4.36,3.3016,16,13,27.638Z"
  })), children);
});
var Report32 = /*#__PURE__*/React.forwardRef(function Report32(_ref224, ref) {
  var children = _ref224.children,
      rest = _objectWithoutProperties(_ref224, _excluded224);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18H18V20H10zM10 13H22V15H10zM10 23H15V25H10z"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
  })), children);
});
var Report24 = /*#__PURE__*/React.forwardRef(function Report24(_ref225, ref) {
  var children = _ref225.children,
      rest = _objectWithoutProperties(_ref225, _excluded225);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18H18V20H10zM10 13H22V15H10zM10 23H15V25H10z"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
  })), children);
});
var Report20 = /*#__PURE__*/React.forwardRef(function Report20(_ref226, ref) {
  var children = _ref226.children,
      rest = _objectWithoutProperties(_ref226, _excluded226);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18H18V20H10zM10 13H22V15H10zM10 23H15V25H10z"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
  })), children);
});
var Report16 = /*#__PURE__*/React.forwardRef(function Report16(_ref227, ref) {
  var children = _ref227.children,
      rest = _objectWithoutProperties(_ref227, _excluded227);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18H18V20H10zM10 13H22V15H10zM10 23H15V25H10z"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
  })), children);
});
var ReportData32 = /*#__PURE__*/React.forwardRef(function ReportData32(_ref228, ref) {
  var children = _ref228.children,
      rest = _objectWithoutProperties(_ref228, _excluded228);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M15 20H17V24H15zM20 18H22V24H20zM10 14H12V24H10z"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
  })), children);
});
var ReportData24 = /*#__PURE__*/React.forwardRef(function ReportData24(_ref229, ref) {
  var children = _ref229.children,
      rest = _objectWithoutProperties(_ref229, _excluded229);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M15 20H17V24H15zM20 18H22V24H20zM10 14H12V24H10z"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
  })), children);
});
var ReportData20 = /*#__PURE__*/React.forwardRef(function ReportData20(_ref230, ref) {
  var children = _ref230.children,
      rest = _objectWithoutProperties(_ref230, _excluded230);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M15 20H17V24H15zM20 18H22V24H20zM10 14H12V24H10z"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
  })), children);
});
var ReportData16 = /*#__PURE__*/React.forwardRef(function ReportData16(_ref231, ref) {
  var children = _ref231.children,
      rest = _objectWithoutProperties(_ref231, _excluded231);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M15 20H17V24H15zM20 18H22V24H20zM10 14H12V24H10z"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
  })), children);
});
var RequestQuote32 = /*#__PURE__*/React.forwardRef(function RequestQuote32(_ref232, ref) {
  var children = _ref232.children,
      rest = _objectWithoutProperties(_ref232, _excluded232);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M22,22v6H6V4H16V2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V22Z"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M29.54,5.76l-3.3-3.3a1.6,1.6,0,0,0-2.24,0l-14,14V22h5.53l14-14a1.6,1.6,0,0,0,0-2.24ZM14.7,20H12V17.3l9.44-9.45,2.71,2.71ZM25.56,9.15,22.85,6.44l2.27-2.27,2.71,2.71Z"
  })), children);
});
var RequestQuote24 = /*#__PURE__*/React.forwardRef(function RequestQuote24(_ref233, ref) {
  var children = _ref233.children,
      rest = _objectWithoutProperties(_ref233, _excluded233);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M22,22v6H6V4H16V2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V22Z"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M29.54,5.76l-3.3-3.3a1.6,1.6,0,0,0-2.24,0l-14,14V22h5.53l14-14a1.6,1.6,0,0,0,0-2.24ZM14.7,20H12V17.3l9.44-9.45,2.71,2.71ZM25.56,9.15,22.85,6.44l2.27-2.27,2.71,2.71Z"
  })), children);
});
var RequestQuote20 = /*#__PURE__*/React.forwardRef(function RequestQuote20(_ref234, ref) {
  var children = _ref234.children,
      rest = _objectWithoutProperties(_ref234, _excluded234);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M22,22v6H6V4H16V2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V22Z"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M29.54,5.76l-3.3-3.3a1.6,1.6,0,0,0-2.24,0l-14,14V22h5.53l14-14a1.6,1.6,0,0,0,0-2.24ZM14.7,20H12V17.3l9.44-9.45,2.71,2.71ZM25.56,9.15,22.85,6.44l2.27-2.27,2.71,2.71Z"
  })), children);
});
var RequestQuote16 = /*#__PURE__*/React.forwardRef(function RequestQuote16(_ref235, ref) {
  var children = _ref235.children,
      rest = _objectWithoutProperties(_ref235, _excluded235);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M22,22v6H6V4H16V2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V22Z"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M29.54,5.76l-3.3-3.3a1.6,1.6,0,0,0-2.24,0l-14,14V22h5.53l14-14a1.6,1.6,0,0,0,0-2.24ZM14.7,20H12V17.3l9.44-9.45,2.71,2.71ZM25.56,9.15,22.85,6.44l2.27-2.27,2.71,2.71Z"
  })), children);
});
var ResearchBlochSphere32 = /*#__PURE__*/React.forwardRef(function ResearchBlochSphere32(_ref236, ref) {
  var children = _ref236.children,
      rest = _objectWithoutProperties(_ref236, _excluded236);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['ResearchBlochSphere32']) {
      didWarnAboutDeprecation['ResearchBlochSphere32'] = true;
      console.warn("The ResearchBlochSphere32 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M21.87,7.84l-1.74-1L16,14h0a2,2,0,1,0,2,2,2,2,0,0,0-.27-1Z"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,2a12,12,0,0,1,11.17,7.65,25.69,25.69,0,0,0-3.69-1.5l-1,1.77a22.7,22.7,0,0,1,5.41,2.39,11.05,11.05,0,0,1,0,3.38A22.92,22.92,0,0,1,16,21,22.92,22.92,0,0,1,4.13,17.69a11.05,11.05,0,0,1,0-3.38A22.8,22.8,0,0,1,15,11V9a25,25,0,0,0-10.17,2.6A12,12,0,0,1,16,4Zm0,24A12,12,0,0,1,4.83,20.35,24.88,24.88,0,0,0,16,23a24.88,24.88,0,0,0,11.17-2.65A12,12,0,0,1,16,28Z"
  })), children);
});
var ResearchBlochSphere24 = /*#__PURE__*/React.forwardRef(function ResearchBlochSphere24(_ref237, ref) {
  var children = _ref237.children,
      rest = _objectWithoutProperties(_ref237, _excluded237);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['ResearchBlochSphere24']) {
      didWarnAboutDeprecation['ResearchBlochSphere24'] = true;
      console.warn("The ResearchBlochSphere24 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M21.87,7.84l-1.74-1L16,14h0a2,2,0,1,0,2,2,2,2,0,0,0-.27-1Z"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,2a12,12,0,0,1,11.17,7.65,25.69,25.69,0,0,0-3.69-1.5l-1,1.77a22.7,22.7,0,0,1,5.41,2.39,11.05,11.05,0,0,1,0,3.38A22.92,22.92,0,0,1,16,21,22.92,22.92,0,0,1,4.13,17.69a11.05,11.05,0,0,1,0-3.38A22.8,22.8,0,0,1,15,11V9a25,25,0,0,0-10.17,2.6A12,12,0,0,1,16,4Zm0,24A12,12,0,0,1,4.83,20.35,24.88,24.88,0,0,0,16,23a24.88,24.88,0,0,0,11.17-2.65A12,12,0,0,1,16,28Z"
  })), children);
});
var ResearchBlochSphere20 = /*#__PURE__*/React.forwardRef(function ResearchBlochSphere20(_ref238, ref) {
  var children = _ref238.children,
      rest = _objectWithoutProperties(_ref238, _excluded238);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['ResearchBlochSphere20']) {
      didWarnAboutDeprecation['ResearchBlochSphere20'] = true;
      console.warn("The ResearchBlochSphere20 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M21.87,7.84l-1.74-1L16,14h0a2,2,0,1,0,2,2,2,2,0,0,0-.27-1Z"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,2a12,12,0,0,1,11.17,7.65,25.69,25.69,0,0,0-3.69-1.5l-1,1.77a22.7,22.7,0,0,1,5.41,2.39,11.05,11.05,0,0,1,0,3.38A22.92,22.92,0,0,1,16,21,22.92,22.92,0,0,1,4.13,17.69a11.05,11.05,0,0,1,0-3.38A22.8,22.8,0,0,1,15,11V9a25,25,0,0,0-10.17,2.6A12,12,0,0,1,16,4Zm0,24A12,12,0,0,1,4.83,20.35,24.88,24.88,0,0,0,16,23a24.88,24.88,0,0,0,11.17-2.65A12,12,0,0,1,16,28Z"
  })), children);
});
var ResearchBlochSphere16 = /*#__PURE__*/React.forwardRef(function ResearchBlochSphere16(_ref239, ref) {
  var children = _ref239.children,
      rest = _objectWithoutProperties(_ref239, _excluded239);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['ResearchBlochSphere16']) {
      didWarnAboutDeprecation['ResearchBlochSphere16'] = true;
      console.warn("The ResearchBlochSphere16 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M21.87,7.84l-1.74-1L16,14h0a2,2,0,1,0,2,2,2,2,0,0,0-.27-1Z"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,2a12,12,0,0,1,11.17,7.65,25.69,25.69,0,0,0-3.69-1.5l-1,1.77a22.7,22.7,0,0,1,5.41,2.39,11.05,11.05,0,0,1,0,3.38A22.92,22.92,0,0,1,16,21,22.92,22.92,0,0,1,4.13,17.69a11.05,11.05,0,0,1,0-3.38A22.8,22.8,0,0,1,15,11V9a25,25,0,0,0-10.17,2.6A12,12,0,0,1,16,4Zm0,24A12,12,0,0,1,4.83,20.35,24.88,24.88,0,0,0,16,23a24.88,24.88,0,0,0,11.17-2.65A12,12,0,0,1,16,28Z"
  })), children);
});
var ResearchHintonPlot32 = /*#__PURE__*/React.forwardRef(function ResearchHintonPlot32(_ref240, ref) {
  var children = _ref240.children,
      rest = _objectWithoutProperties(_ref240, _excluded240);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['ResearchHintonPlot32']) {
      didWarnAboutDeprecation['ResearchHintonPlot32'] = true;
      console.warn("The ResearchHintonPlot32 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H6V6H2zM10 2H14V6H10zM18 2H22V6H18zM26 2H30V6H26zM2 10H6V14H2zM10 10H14V14H10zM18 10H22V14H18zM26 10H30V14H26zM2 18H6V22H2zM10 18H14V22H10zM18 18H22V22H18zM26 18H30V22H26zM2 26H6V30H2zM10 26H14V30H10zM18 26H22V30H18zM26 26H30V30H26z"
  })), children);
});
var ResearchHintonPlot24 = /*#__PURE__*/React.forwardRef(function ResearchHintonPlot24(_ref241, ref) {
  var children = _ref241.children,
      rest = _objectWithoutProperties(_ref241, _excluded241);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['ResearchHintonPlot24']) {
      didWarnAboutDeprecation['ResearchHintonPlot24'] = true;
      console.warn("The ResearchHintonPlot24 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H6V6H2zM10 2H14V6H10zM18 2H22V6H18zM26 2H30V6H26zM2 10H6V14H2zM10 10H14V14H10zM18 10H22V14H18zM26 10H30V14H26zM2 18H6V22H2zM10 18H14V22H10zM18 18H22V22H18zM26 18H30V22H26zM2 26H6V30H2zM10 26H14V30H10zM18 26H22V30H18zM26 26H30V30H26z"
  })), children);
});
var ResearchHintonPlot20 = /*#__PURE__*/React.forwardRef(function ResearchHintonPlot20(_ref242, ref) {
  var children = _ref242.children,
      rest = _objectWithoutProperties(_ref242, _excluded242);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['ResearchHintonPlot20']) {
      didWarnAboutDeprecation['ResearchHintonPlot20'] = true;
      console.warn("The ResearchHintonPlot20 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H6V6H2zM10 2H14V6H10zM18 2H22V6H18zM26 2H30V6H26zM2 10H6V14H2zM10 10H14V14H10zM18 10H22V14H18zM26 10H30V14H26zM2 18H6V22H2zM10 18H14V22H10zM18 18H22V22H18zM26 18H30V22H26zM2 26H6V30H2zM10 26H14V30H10zM18 26H22V30H18zM26 26H30V30H26z"
  })), children);
});
var ResearchHintonPlot16 = /*#__PURE__*/React.forwardRef(function ResearchHintonPlot16(_ref243, ref) {
  var children = _ref243.children,
      rest = _objectWithoutProperties(_ref243, _excluded243);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['ResearchHintonPlot16']) {
      didWarnAboutDeprecation['ResearchHintonPlot16'] = true;
      console.warn("The ResearchHintonPlot16 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H6V6H2zM10 2H14V6H10zM18 2H22V6H18zM26 2H30V6H26zM2 10H6V14H2zM10 10H14V14H10zM18 10H22V14H18zM26 10H30V14H26zM2 18H6V22H2zM10 18H14V22H10zM18 18H22V22H18zM26 18H30V22H26zM2 26H6V30H2zM10 26H14V30H10zM18 26H22V30H18zM26 26H30V30H26z"
  })), children);
});
var ResearchMatrix32 = /*#__PURE__*/React.forwardRef(function ResearchMatrix32(_ref244, ref) {
  var children = _ref244.children,
      rest = _objectWithoutProperties(_ref244, _excluded244);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['ResearchMatrix32']) {
      didWarnAboutDeprecation['ResearchMatrix32'] = true;
      console.warn("The ResearchMatrix32 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M18 13L18 4 16 4 16 6 13 6 13 8 16 8 16 13 13 13 13 15 21 15 21 13 18 13zM16.5 20A3.5 3.5 0 1113 23.5 3.5 3.5 0 0116.5 20m0-2A5.5 5.5 0 1022 23.5 5.5 5.5 0 0016.5 18zM8 30L2 30 2 2 8 2 8 4 4 4 4 28 8 28 8 30zM30 30L24 30 24 28 28 28 28 4 24 4 24 2 30 2 30 30z"
  })), children);
});
var ResearchMatrix24 = /*#__PURE__*/React.forwardRef(function ResearchMatrix24(_ref245, ref) {
  var children = _ref245.children,
      rest = _objectWithoutProperties(_ref245, _excluded245);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['ResearchMatrix24']) {
      didWarnAboutDeprecation['ResearchMatrix24'] = true;
      console.warn("The ResearchMatrix24 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M18 13L18 4 16 4 16 6 13 6 13 8 16 8 16 13 13 13 13 15 21 15 21 13 18 13zM16.5 20A3.5 3.5 0 1113 23.5 3.5 3.5 0 0116.5 20m0-2A5.5 5.5 0 1022 23.5 5.5 5.5 0 0016.5 18zM8 30L2 30 2 2 8 2 8 4 4 4 4 28 8 28 8 30zM30 30L24 30 24 28 28 28 28 4 24 4 24 2 30 2 30 30z"
  })), children);
});
var ResearchMatrix20 = /*#__PURE__*/React.forwardRef(function ResearchMatrix20(_ref246, ref) {
  var children = _ref246.children,
      rest = _objectWithoutProperties(_ref246, _excluded246);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['ResearchMatrix20']) {
      didWarnAboutDeprecation['ResearchMatrix20'] = true;
      console.warn("The ResearchMatrix20 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M18 13L18 4 16 4 16 6 13 6 13 8 16 8 16 13 13 13 13 15 21 15 21 13 18 13zM16.5 20A3.5 3.5 0 1113 23.5 3.5 3.5 0 0116.5 20m0-2A5.5 5.5 0 1022 23.5 5.5 5.5 0 0016.5 18zM8 30L2 30 2 2 8 2 8 4 4 4 4 28 8 28 8 30zM30 30L24 30 24 28 28 28 28 4 24 4 24 2 30 2 30 30z"
  })), children);
});
var ResearchMatrix16 = /*#__PURE__*/React.forwardRef(function ResearchMatrix16(_ref247, ref) {
  var children = _ref247.children,
      rest = _objectWithoutProperties(_ref247, _excluded247);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['ResearchMatrix16']) {
      didWarnAboutDeprecation['ResearchMatrix16'] = true;
      console.warn("The ResearchMatrix16 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M18 13L18 4 16 4 16 6 13 6 13 8 16 8 16 13 13 13 13 15 21 15 21 13 18 13zM16.5 20A3.5 3.5 0 1113 23.5 3.5 3.5 0 0116.5 20m0-2A5.5 5.5 0 1022 23.5 5.5 5.5 0 0016.5 18zM8 30L2 30 2 2 8 2 8 4 4 4 4 28 8 28 8 30zM30 30L24 30 24 28 28 28 28 4 24 4 24 2 30 2 30 30z"
  })), children);
});
var Reset32 = /*#__PURE__*/React.forwardRef(function Reset32(_ref248, ref) {
  var children = _ref248.children,
      rest = _objectWithoutProperties(_ref248, _excluded248);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M18,28A12,12,0,1,0,6,16v6.2L2.4,18.6,1,20l6,6,6-6-1.4-1.4L8,22.2V16H8A10,10,0,1,1,18,26Z"
  })), children);
});
var Reset24 = /*#__PURE__*/React.forwardRef(function Reset24(_ref249, ref) {
  var children = _ref249.children,
      rest = _objectWithoutProperties(_ref249, _excluded249);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M18,28A12,12,0,1,0,6,16v6.2L2.4,18.6,1,20l6,6,6-6-1.4-1.4L8,22.2V16H8A10,10,0,1,1,18,26Z"
  })), children);
});
var Reset20 = /*#__PURE__*/React.forwardRef(function Reset20(_ref250, ref) {
  var children = _ref250.children,
      rest = _objectWithoutProperties(_ref250, _excluded250);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M18,28A12,12,0,1,0,6,16v6.2L2.4,18.6,1,20l6,6,6-6-1.4-1.4L8,22.2V16H8A10,10,0,1,1,18,26Z"
  })), children);
});

export { Portfolio16, Portfolio20, Portfolio24, Power16, Power20, Power24, Power32, Ppt16, Ppt20, Ppt24, Ppt32, PresentationFile16, PresentationFile20, PresentationFile24, PresentationFile32, Pressure16, Pressure20, Pressure24, Pressure32, PressureFilled16, PressureFilled20, PressureFilled24, PressureFilled32, PreviousFilled16, PreviousFilled20, PreviousFilled24, PreviousFilled32, PreviousOutline16, PreviousOutline20, PreviousOutline24, PreviousOutline32, Printer16, Printer20, Printer24, Printer32, Product16, Product20, Product24, Product32, ProgressBar16, ProgressBar20, ProgressBar24, ProgressBar32, ProgressBarRound16, ProgressBarRound20, ProgressBarRound24, ProgressBarRound32, Purchase16, Purchase20, Purchase24, Purchase32, QqPlot16, QqPlot20, QqPlot24, QqPlot32, QrCode16, QrCode20, QrCode24, QrCode32, QuadrantPlot16, QuadrantPlot20, QuadrantPlot24, QuadrantPlot32, Query16, Query20, Query24, Query32, QueryQueue16, QueryQueue20, QueryQueue24, QueryQueue32, Queued16, Queued20, Queued24, Queued32, Quotes16, Quotes20, Quotes24, Quotes32, Radar16, Radar20, Radar24, Radar32, RadarEnhanced16, RadarEnhanced20, RadarEnhanced24, RadarEnhanced32, RadarWeather16, RadarWeather20, RadarWeather24, RadarWeather32, Radio16, Radio20, Radio24, Radio32, RadioButton16, RadioButton20, RadioButton24, RadioButton32, RadioButtonChecked16, RadioButtonChecked20, RadioButtonChecked24, RadioButtonChecked32, RadioCombat16, RadioCombat20, RadioCombat24, RadioCombat32, RadioPushToTalk16, RadioPushToTalk20, RadioPushToTalk24, RadioPushToTalk32, Rain16, Rain20, Rain24, Rain32, RainDrizzle16, RainDrizzle20, RainDrizzle24, RainDrizzle32, RainDrop16, RainDrop20, RainDrop24, RainDrop32, RainHeavy16, RainHeavy20, RainHeavy24, RainHeavy32, RainScattered16, RainScattered20, RainScattered24, RainScattered32, RainScatteredNight16, RainScatteredNight20, RainScatteredNight24, RainScatteredNight32, Raw16, Raw20, Raw24, Raw32, Receipt16, Receipt20, Receipt24, Receipt32, RecentlyViewed16, RecentlyViewed20, RecentlyViewed24, RecentlyViewed32, Recommend16, Recommend20, Recommend24, Recommend32, Recording16, Recording20, Recording24, Recording32, RecordingFilled16, RecordingFilled20, RecordingFilled24, RecordingFilled32, RecordingFilledAlt16, RecordingFilledAlt20, RecordingFilledAlt24, RecordingFilledAlt32, Redo16, Redo20, Redo24, Redo32, RefEvapotranspiration16, RefEvapotranspiration20, RefEvapotranspiration24, RefEvapotranspiration32, ReflectHorizontal16, ReflectHorizontal20, ReflectHorizontal24, ReflectHorizontal32, ReflectVertical16, ReflectVertical20, ReflectVertical24, ReflectVertical32, Reminder16, Reminder20, Reminder24, Reminder32, ReminderMedical16, ReminderMedical20, ReminderMedical24, ReminderMedical32, Renew16, Renew20, Renew24, Renew32, Repeat16, Repeat20, Repeat24, Repeat32, RepeatOne16, RepeatOne20, RepeatOne24, RepeatOne32, Replicate16, Replicate20, Replicate24, Replicate32, Reply16, Reply20, Reply24, Reply32, ReplyAll16, ReplyAll20, ReplyAll24, ReplyAll32, Report16, Report20, Report24, Report32, ReportData16, ReportData20, ReportData24, ReportData32, RequestQuote16, RequestQuote20, RequestQuote24, RequestQuote32, ResearchBlochSphere16, ResearchBlochSphere20, ResearchBlochSphere24, ResearchBlochSphere32, ResearchHintonPlot16, ResearchHintonPlot20, ResearchHintonPlot24, ResearchHintonPlot32, ResearchMatrix16, ResearchMatrix20, ResearchMatrix24, ResearchMatrix32, Reset20, Reset24, Reset32, WatsonHealthRegionAnalysisArea16, WatsonHealthRegionAnalysisArea20, WatsonHealthRegionAnalysisArea24, WatsonHealthRegionAnalysisArea32, WatsonHealthRegionAnalysisVolume16, WatsonHealthRegionAnalysisVolume20, WatsonHealthRegionAnalysisVolume24, WatsonHealthRegionAnalysisVolume32, WatsonHealthRegistration16, WatsonHealthRegistration20, WatsonHealthRegistration24, WatsonHealthRegistration32 };
